var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var _KitPersonalisation_instances, modal_get, trigger_get, closeBtns_get, nameInput_get, numberInput_get, fontRadios_get, typeButtons_get, steps_get, badgesEl_get, badgeButtons_get, specialsEl_get, specialButtons_get, playerField_get, modalBody_get, fieldsEl_get, categoryButtons_get, playerDropdown_get, playerTabs_get, playerTabsList_get, playerCardsEl_get, playerCarousel_get, playerArrows_get, playerEmptyEl_get, playerCards_get, visiblePlayerCards_get, nameField_get, numberField_get, stepBackBtns_get, typeNavItems_get, errorEls_get, titleEl_get, stepTitleEl_get, summaryEl_get, subtitleEl_get, ctaLabelEl_get, previewNameTextPath_get, previewNameStroke_get, previewNameImages_get, previewNameImageArc_get, previewNumber_get, previewNumberStroke_get, previewNumberImages_get, previewContainer_get, previewSvg_get, previewNameArc_get, confirmOverlay_get, confirmCard_get, confirmBasePriceEl_get, confirmOptionsEl_get, confirmPersonalisationRow_get, confirmPersonalisationLabelEl_get, confirmPersonalisationValueEl_get, confirmPersonalisationPriceEl_get, confirmFontRow_get, confirmFontValueEl_get, confirmBadgesRow_get, confirmBadgesValueEl_get, confirmBadgesPriceEl_get, confirmCancelBtn_get, confirmAddBtn_get, nameCountEl_get, isShortsMode_get, _controller, _feeProduct, _debounceTimer, _selectedType, _selectedPlayer, _selectedCategory, _confirmedSnapshot, _confirmed, _layoutObserver, _lettersHandles, _numbersHandles, _variantsById, _optionNames, parseHandles_fn, loadProducts_fn, handlesForFont_fn, stepForType_fn, updateStepTitle_fn, showStep_fn, _stepExitTimers, exitStep_fn, cancelStepExit_fn, _openModal, _closeModal, _onDoneClick, openConfirmOverlay_fn, closeConfirmOverlay_fn, _onConfirmCancel, _onConfirmAdd, confirmPersonalisationLabel_get, confirmSpecialLabel_get, confirmNoneLabel_get, formatMoney_fn, formatAddOnPrice_fn, _onTypeSelect, autoSelectDefaultPlayer_fn, selectCategory_fn, selectFirstVisiblePlayerCard_fn, activePosition_fn, filterPlayerCards_fn, activateTab_fn, updateTabIndicator_fn, toggleFieldsForType_fn, _onBack, _onModalClose, _onCancel, _onBackdropClick, _onNameInput, _onNameKeydown, _onNumberInput, _onNumberKeydown, _onCategoryClick, _onPlayerTabClick, _isDraggingPlayers, _playerDragStart, initPlayerCarousel_fn, _updateCarouselArrows, _onPlayerArrowClick, _onPlayerPointerDown, _onPlayerPointerMove, _onPlayerPointerUp, _onPlayerCardsClickCapture, _onPlayerCardClick, _onTypeNavClick, updateTypeNav_fn, getSelectedPlayerName_fn, getSelectedPlayerNumber_fn, _onFontChange, badgeMax_fn, getSelectedBadges_fn, badgeRules_fn, updateBadgeAvailability_fn, _onBadgeClick, updateBadgeState_fn, getSelectedSpecials_fn, _onSpecialClick, updateSpecialState_fn, debouncedPreview_fn, getSelectedFont_fn, _printLayout, ascentRatio_fn, _ascentRatios, artboxUnits_fn, applyNameArc_fn, applyNameImageArc_fn, layoutNameImages_fn, bodyBoxesFor_fn, _accentScaleSource, _unmeasuredWarned, _nameImageLetters, _nameImageNodes, _nameImagesKey, _namePreviewToken, letterArtwork_fn, renderNameImages_fn, updateNamePreview_fn, currentNameSize_fn, applyPrintLayout_fn, positionDigitBand_fn, numberSizeForHeight_fn, _numberEmRatio, fixed_fn, nameSizeForArc_fn, updatePreview_fn, updateNumberPreview_fn, guidesEnabled_fn, _guidesGroup, _guidesBand, _guidesReadout, _guidesObserver, initPreviewGuides_fn, _guideSummary, layoutValue_fn, buildGuideControls_fn, currentArcD_fn, artboxOverflow_fn, round_fn, applyGuideValues_fn, digitBandDescription_fn, letterArtworkDescription_fn, updateGuideSummary_fn, updateGuides_fn, updatePreviewFont_fn, coloursForFont_fn, nameMaxLength_fn, updateNameCount_fn, nameNumberText_fn, otherOptionsText_fn, updateTriggerState_fn, showError_fn, clearError_fn, interceptForm_fn, _form, _currentGroupKey, _onFormSubmit, syncFormProperties_fn, checkStock_fn, checkCharacterStock_fn, _stockCheckPromise, _stockCheckKey, currentPersonalisation_fn, prewarmStockCheck_fn, addPersonalisedToCart_fn, buildShirtItem_fn, cartSectionIds_fn, clearCustomInputs_fn, clearPlayerSelection_fn, clearPlayerInput_fn, clearSpecialInputs_fn, reset_fn, captureSnapshot_fn, restoreSnapshot_fn, hasNameOrNumber_fn, hasPersonalisation_fn;
import { formatMoney } from "@theme/money-formatting";
const productCache = /* @__PURE__ */ new Map();
function fetchProduct(handle) {
  if (productCache.has(handle)) return productCache.get(handle);
  const promise = fetch(`/products/${handle}.js`).then((res) => {
    if (!res.ok) throw new Error(`Product "${handle}" not found (${res.status})`);
    return res.json();
  });
  productCache.set(handle, promise);
  return promise;
}
const BELOW_BASELINE_MARKS = /* @__PURE__ */ new Set([
  "\u0323",
  // dot below
  "\u0326",
  // comma below
  "\u0327",
  // cedilla
  "\u0328"
  // ogonek
]);
function accentPlacement(char) {
  const marks = char.normalize("NFD").slice(1);
  if (!marks) return "none";
  for (const mark of marks) {
    if (BELOW_BASELINE_MARKS.has(mark)) return "below";
  }
  return "above";
}
const imageMetricsCache = /* @__PURE__ */ new Map();
function loadImageMetrics(src) {
  const cached = imageMetricsCache.get(src);
  if (cached) return cached;
  const promise = new Promise((resolve) => {
    const img = new Image();
    img.addEventListener("load", () => {
      const height = img.naturalHeight || 1;
      resolve({ aspect: img.naturalWidth / height, height });
    });
    img.addEventListener("error", () => resolve({ aspect: 1, height: 0 }));
    img.src = src;
  });
  imageMetricsCache.set(src, promise);
  return promise;
}
function findVariant(variants, character) {
  return variants.find((v) => v.option1 === character);
}
function findFeeVariant(variants) {
  return variants.find((v) => v.sku && v.available);
}
const FONT_CLASS_MAP = {
  PALACE: "kit-personalisation__preview--palace",
  "Premier League": "kit-personalisation__preview--premier-league",
  WSL: "kit-personalisation__preview--wsl"
};
const BADGE_UNAVAILABLE_CLASS = "kit-personalisation__badge-option--unavailable";
const FONT_HANDLE_KEY = {
  PALACE: "palace",
  "Premier League": "pl",
  WSL: "wsl"
};
function normaliseKey(value) {
  return String(value ?? "").trim().toLowerCase();
}
const FONT_KEY_BY_LABEL = new Map(
  Object.entries(FONT_HANDLE_KEY).map(([label, key]) => [normaliseKey(label), key])
);
function toFontKey(value) {
  const normalised = normaliseKey(value);
  return FONT_KEY_BY_LABEL.get(normalised) ?? normalised;
}
const COLOUR_MAP = {
  white: "#ffffff",
  black: "#0a0a0a",
  red: "#ef2f25",
  blue: "#02468c",
  green: "#8fee9c"
};
const NAME_MEASURE_SIZE = 100;
const NAME_SIZE_MIN = 14;
const NAME_FALLBACK_ADVANCE = 0.6;
const SPACE_ASPECT = 0.35;
const ACCENT_FRACTION_MIN = 0.5;
const TANGENT_SAMPLE = 1;
const NAME_ARTWORK_CLASS = "kit-personalisation__preview-container--name-artwork";
const PRINT_LAYOUT = {
  /** % of the viewBox */
  artbox: { x: 31, y: 30, width: 38, height: 46 },
  name: {
    /** % of artbox width held back from each end of the arc */
    inset: 6.5,
    /**
     * % of artbox height, where the name's TOP edge sits — a ceiling the
     * text hangs from, which stays put as the size changes. The arc drawn
     * from it is the baseline, one measured ascent lower (see #applyNameArc).
     *
     * 4, not the 7 this was tuned to: top-anchoring used to go through
     * dominant-baseline: hanging, which pins the font's hanging-baseline
     * metric rather than the actual glyph top. The two sit 5.6 units apart
     * here, so this backs that out to leave the name where it was tuned.
     */
    top: 4,
    /** % of artbox width the arc's midpoint rises by */
    curveDepth: 0,
    /** proportion of the arc's length the name should span */
    fill: 0.93,
    /** ceiling in viewBox units, so a short name can't fill the shirt */
    maxSize: 29,
    /**
     * The name has the same two renderers as the number, and for the same
     * reason: `image` is the printed letter artwork, which carries its own
     * padding and bearings and so doesn't sit where the live text does. It
     * follows the same arc — `inset` and `curveDepth` above are shared, so
     * there's still one curve to get right — and differs only in how it's
     * anchored and sized, since cut vinyl has no font metrics to hang from.
     */
    image: {
      /** % of artbox height, where the letters' TOP edge sits on the arc */
      top: 6,
      /** ceiling on letter height, % of artbox height */
      maxHeight: 14,
      /** tracking between letters, % of letter height. Cut vinyl is
       *  supplied tight-cropped, so without this the letters touch. */
      gap: 11.5,
      /**
       * Fallback for accented letters whose artwork couldn't be measured.
       *
       * Normally unused: the body's extent is read from the artwork's pixels
       * (see #bodyBoxesFor), which needs no configuration and copes with any
       * export size. This only applies when the base letter has no artwork on
       * the sheet, leaving nothing to compare the accented one against. It is
       * canvasHeight / bodyHeight for the artwork in use. Tune it against a
       * real accented letter with ?kit-guides.
       */
      accentScale: 1.25,
      /** proportion of the arc's length the letters should span */
      fill: 0.93
    }
  },
  /**
   * The number has two renderers with their own placement, because they're
   * not interchangeable: `text` is live glyphs measured from the font, while
   * `image` is the printed character artwork, which carries its own padding
   * and bearings and so rarely sits right at the text's numbers. Both are
   * percentages of the artbox.
   */
  number: {
    text: {
      /** % of artbox height, where the top edge sits */
      top: 25,
      /** % of artbox height the glyphs should stand */
      height: 59,
      /** % of artbox width to nudge sideways; 0 is centred */
      xOffset: 2
    },
    image: {
      top: 26.5,
      height: 46,
      xOffset: 0,
      /** % of artbox width the digits are centred within */
      width: 62
    }
  }
};
const VIEWBOX_SIZE = 400;
const NUMBER_MEASURE_SIZE = 100;
const STEP_EXIT_DURATION = 350;
const NUMBER_EM_HEIGHT_FALLBACK = 1.05;
const ASCENT_RATIO_FALLBACK = 0.75;
const STROKE_COLOUR_MAP = {
  white: "#0a0a0a",
  black: "#ffffff",
  red: "#ffffff",
  blue: "#ffffff",
  green: "#0a0a0a",
  yellow: "#0a0a0a"
};
function findHandleForFont(handles, fontKey) {
  return handles.find((h) => {
    const parts = h.split("-");
    return parts[1] === fontKey;
  });
}
class KitPersonalisation extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _KitPersonalisation_instances);
    __privateAdd(this, _controller, new AbortController());
    /** @type {object | null} */
    __privateAdd(this, _feeProduct, null);
    /** @type {number | null} */
    __privateAdd(this, _debounceTimer, null);
    /** @type {string | null} */
    __privateAdd(this, _selectedType, null);
    /** @type {{ name: string, number: string } | null} */
    __privateAdd(this, _selectedPlayer, null);
    /** @type {string | null} */
    __privateAdd(this, _selectedCategory, null);
    /**
     * Snapshot of the last *confirmed* personalisation — i.e. what was in
     * place the last time the customer hit the modal's own "Add to
     * basket"/Done button, or the blank state if nothing has been confirmed
     * yet. Restored whenever the modal is dismissed (✕, backdrop, Escape)
     * without re-confirming, so unconfirmed edits never reach the cart.
     * @type {object | null}
     */
    __privateAdd(this, _confirmedSnapshot, null);
    /** Set only by the Done/"Add to basket" button; read then reset on close. */
    __privateAdd(this, _confirmed, false);
    /** @type {ResizeObserver | null} */
    __privateAdd(this, _layoutObserver, null);
    /** @type {string[]} */
    __privateAdd(this, _lettersHandles, []);
    /** @type {string[]} */
    __privateAdd(this, _numbersHandles, []);
    /** @type {Record<string, { price: number, option1: string|null, option2: string|null, option3: string|null }>} */
    __privateAdd(this, _variantsById, {});
    /** @type {string[]} */
    __privateAdd(this, _optionNames, []);
    /** Timers that finish a step's exit, keyed by the step element. */
    __privateAdd(this, _stepExitTimers, /* @__PURE__ */ new WeakMap());
    __privateAdd(this, _openModal, () => {
      const modal = __privateGet(this, _KitPersonalisation_instances, modal_get);
      if (!modal) return;
      modal.classList.remove("kit-personalisation__modal--closing");
      const step = __privateGet(this, _KitPersonalisation_instances, isShortsMode_get) ? "details" : "type";
      modal.dataset.step = step;
      modal.showModal();
      document.documentElement.setAttribute("scroll-lock", "");
      modal.offsetHeight;
      modal.classList.add("kit-personalisation__modal--open");
      if (__privateGet(this, _KitPersonalisation_instances, isShortsMode_get)) {
        __privateMethod(this, _KitPersonalisation_instances, toggleFieldsForType_fn).call(this, "custom");
        __privateMethod(this, _KitPersonalisation_instances, updateStepTitle_fn).call(this, "custom");
      }
      __privateMethod(this, _KitPersonalisation_instances, showStep_fn).call(this, step);
      __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
      if (__privateMethod(this, _KitPersonalisation_instances, guidesEnabled_fn).call(this) && !__privateGet(this, _guidesGroup)) __privateMethod(this, _KitPersonalisation_instances, initPreviewGuides_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, applyPrintLayout_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
    });
    __privateAdd(this, _closeModal, () => {
      const modal = __privateGet(this, _KitPersonalisation_instances, modal_get);
      if (!modal) return;
      for (const step of __privateGet(this, _KitPersonalisation_instances, steps_get)) {
        if (!step.hidden) __privateMethod(this, _KitPersonalisation_instances, exitStep_fn).call(this, step);
      }
      modal.classList.add("kit-personalisation__modal--closing");
      modal.classList.remove("kit-personalisation__modal--open");
      document.documentElement.removeAttribute("scroll-lock");
      const onEnd = (e) => {
        if (e.target !== modal || e.propertyName !== "transform") return;
        modal.removeEventListener("transitionend", onEnd);
        modal.close();
      };
      modal.addEventListener("transitionend", onEnd);
      setTimeout(() => {
        if (modal.open) modal.close();
        modal.classList.remove("kit-personalisation__modal--closing");
      }, 400);
    });
    /**
     * "Continue" no longer confirms directly — it opens the order summary
     * overlay so the customer can review what they've picked and its cost
     * before committing. The actual confirm happens in #onConfirmAdd.
     */
    __privateAdd(this, _onDoneClick, () => {
      __privateMethod(this, _KitPersonalisation_instances, openConfirmOverlay_fn).call(this);
    });
    __privateAdd(this, _onConfirmCancel, () => {
      __privateMethod(this, _KitPersonalisation_instances, closeConfirmOverlay_fn).call(this);
    });
    __privateAdd(this, _onConfirmAdd, async () => {
      if (!__privateGet(this, _form)) return;
      __privateSet(this, _confirmed, true);
      __privateSet(this, _confirmedSnapshot, __privateMethod(this, _KitPersonalisation_instances, captureSnapshot_fn).call(this));
      __privateGet(this, _KitPersonalisation_instances, confirmAddBtn_get)?.setAttribute("disabled", "disabled");
      const added = await __privateMethod(this, _KitPersonalisation_instances, addPersonalisedToCart_fn).call(this, __privateGet(this, _form));
      __privateGet(this, _KitPersonalisation_instances, confirmAddBtn_get)?.removeAttribute("disabled");
      if (added) {
        __privateMethod(this, _KitPersonalisation_instances, closeConfirmOverlay_fn).call(this);
        __privateGet(this, _closeModal).call(this);
      }
    });
    __privateAdd(this, _onTypeSelect, (e) => {
      const btn = e.currentTarget;
      if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
      __privateSet(this, _selectedType, btn.dataset.kitType);
      if (__privateGet(this, _selectedType) === "special") {
        __privateMethod(this, _KitPersonalisation_instances, clearCustomInputs_fn).call(this);
        __privateMethod(this, _KitPersonalisation_instances, clearPlayerInput_fn).call(this);
      } else if (__privateGet(this, _selectedType) === "player") {
        __privateMethod(this, _KitPersonalisation_instances, clearCustomInputs_fn).call(this);
        __privateMethod(this, _KitPersonalisation_instances, clearSpecialInputs_fn).call(this);
      } else {
        __privateMethod(this, _KitPersonalisation_instances, clearPlayerInput_fn).call(this);
        __privateMethod(this, _KitPersonalisation_instances, clearSpecialInputs_fn).call(this);
      }
      __privateMethod(this, _KitPersonalisation_instances, toggleFieldsForType_fn).call(this, __privateGet(this, _selectedType));
      if (__privateGet(this, _selectedType) === "player") __privateMethod(this, _KitPersonalisation_instances, autoSelectDefaultPlayer_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updateStepTitle_fn).call(this, __privateGet(this, _selectedType));
      __privateMethod(this, _KitPersonalisation_instances, showStep_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, stepForType_fn).call(this, __privateGet(this, _selectedType)));
      __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
    });
    __privateAdd(this, _onBack, () => {
      __privateMethod(this, _KitPersonalisation_instances, updateStepTitle_fn).call(this, null);
      __privateMethod(this, _KitPersonalisation_instances, showStep_fn).call(this, "type");
    });
    __privateAdd(this, _onModalClose, () => {
      __privateGet(this, _KitPersonalisation_instances, modal_get)?.classList.remove("kit-personalisation__modal--open");
      __privateGet(this, _KitPersonalisation_instances, modal_get)?.classList.remove("kit-personalisation__modal--closing");
      document.documentElement.removeAttribute("scroll-lock");
      if (!__privateGet(this, _confirmed)) {
        __privateMethod(this, _KitPersonalisation_instances, restoreSnapshot_fn).call(this, __privateGet(this, _confirmedSnapshot));
      }
      __privateSet(this, _confirmed, false);
      __privateMethod(this, _KitPersonalisation_instances, updateTriggerState_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    __privateAdd(this, _onCancel, (e) => {
      e.preventDefault();
      __privateGet(this, _closeModal).call(this);
    });
    __privateAdd(this, _onBackdropClick, (e) => {
      if (e.target === __privateGet(this, _KitPersonalisation_instances, modal_get)) {
        __privateGet(this, _closeModal).call(this);
      }
    });
    // ── Name / number inputs ────────────────────────────────────────────────
    __privateAdd(this, _onNameInput, () => {
      const input = __privateGet(this, _KitPersonalisation_instances, nameInput_get);
      if (!input) return;
      input.value = input.value.normalize("NFC").replace(/[^\p{Script=Latin}\p{Mark} ]/gu, "").replace(/ {2,}/g, " ").replace(/^ +/, "").toUpperCase();
      __privateMethod(this, _KitPersonalisation_instances, updateNameCount_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, debouncedPreview_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    /**
     * Block non-alpha keys on name input.
     *
     * @param {KeyboardEvent} e
     */
    __privateAdd(this, _onNameKeydown, (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key))
        return;
      if (e.key.length === 1 && !/[\p{Script=Latin} ]/u.test(e.key)) {
        e.preventDefault();
      }
    });
    __privateAdd(this, _onNumberInput, () => {
      const input = __privateGet(this, _KitPersonalisation_instances, numberInput_get);
      if (!input) return;
      input.value = input.value.replace(/[^0-9]/g, "");
      __privateMethod(this, _KitPersonalisation_instances, debouncedPreview_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    /**
     * Block non-digit keys on number input.
     *
     * @param {KeyboardEvent} e
     */
    __privateAdd(this, _onNumberKeydown, (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key))
        return;
      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault();
      }
    });
    __privateAdd(this, _onCategoryClick, (e) => {
      const btn = e.currentTarget;
      const category = btn.dataset.kitCategory;
      if (!category) return;
      __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, selectCategory_fn).call(this, btn, category);
      __privateMethod(this, _KitPersonalisation_instances, clearPlayerSelection_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, selectFirstVisiblePlayerCard_fn).call(this);
    });
    /**
     * Position filter tabs above the player carousel — functions like the
     * PDP's product-tabs (role=tablist/tab/tabpanel, aria-selected toggling,
     * hidden attribute on panels).
     */
    __privateAdd(this, _onPlayerTabClick, (e) => {
      const tab = e.currentTarget;
      if (!tab.dataset.kitPlayerTab) return;
      __privateMethod(this, _KitPersonalisation_instances, activateTab_fn).call(this, tab);
      __privateMethod(this, _KitPersonalisation_instances, filterPlayerCards_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, selectFirstVisiblePlayerCard_fn).call(this);
    });
    // ── Player carousel (arrow navigation + drag to scroll) ─────────────────
    /** True once a pointer drag has moved far enough to count as a scroll. */
    __privateAdd(this, _isDraggingPlayers, false);
    /** @type {{ pointerId: number, startX: number, startScrollLeft: number } | null} */
    __privateAdd(this, _playerDragStart, null);
    /**
     * Toggles each arrow according to whether there's anything left to scroll
     * to in that direction (and hides both when the row doesn't overflow).
     */
    __privateAdd(this, _updateCarouselArrows, () => {
      const scroller = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
      if (!scroller) return;
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const overflows = maxScroll > 1;
      for (const btn of __privateGet(this, _KitPersonalisation_instances, playerArrows_get)) {
        const isPrev = btn.dataset.kitPlayerArrow === "prev";
        const atEnd = isPrev ? scroller.scrollLeft <= 1 : scroller.scrollLeft >= maxScroll - 1;
        btn.hidden = !overflows || atEnd;
      }
    });
    __privateAdd(this, _onPlayerArrowClick, (e) => {
      const scroller = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
      if (!scroller) return;
      const direction = e.currentTarget.dataset.kitPlayerArrow === "prev" ? -1 : 1;
      const card = __privateGet(this, _KitPersonalisation_instances, visiblePlayerCards_get)[0];
      const gap = Number.parseFloat(getComputedStyle(scroller).columnGap) || 0;
      const cardStep = card ? card.offsetWidth + gap : 0;
      const step = cardStep ? cardStep * Math.max(1, Math.floor(scroller.clientWidth / cardStep) - 1) : scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: step * direction, behavior: "smooth" });
    });
    __privateAdd(this, _onPlayerPointerDown, (e) => {
      if (e.pointerType === "touch" || e.button !== 0) return;
      const scroller = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
      if (!scroller) return;
      __privateSet(this, _isDraggingPlayers, false);
      __privateSet(this, _playerDragStart, {
        pointerId: e.pointerId,
        startX: e.clientX,
        startScrollLeft: scroller.scrollLeft
      });
    });
    __privateAdd(this, _onPlayerPointerMove, (e) => {
      const start = __privateGet(this, _playerDragStart);
      const scroller = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
      if (!start || !scroller || e.pointerId !== start.pointerId) return;
      const dx = e.clientX - start.startX;
      if (!__privateGet(this, _isDraggingPlayers)) {
        if (Math.abs(dx) < 5) return;
        __privateSet(this, _isDraggingPlayers, true);
        scroller.setPointerCapture(e.pointerId);
        scroller.classList.add("kit-personalisation__player-cards--dragging");
      }
      scroller.scrollLeft = start.startScrollLeft - dx;
    });
    __privateAdd(this, _onPlayerPointerUp, (e) => {
      const start = __privateGet(this, _playerDragStart);
      const scroller = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
      if (!start || e.pointerId !== start.pointerId) return;
      __privateSet(this, _playerDragStart, null);
      if (!scroller) return;
      if (scroller.hasPointerCapture(e.pointerId)) scroller.releasePointerCapture(e.pointerId);
      scroller.classList.remove("kit-personalisation__player-cards--dragging");
    });
    __privateAdd(this, _onPlayerCardsClickCapture, (e) => {
      if (!__privateGet(this, _isDraggingPlayers)) return;
      __privateSet(this, _isDraggingPlayers, false);
      e.preventDefault();
      e.stopPropagation();
    });
    __privateAdd(this, _onPlayerCardClick, (e) => {
      const btn = e.currentTarget;
      const name = btn.dataset.playerName ?? "";
      const number = btn.dataset.playerNumber ?? "";
      __privateSet(this, _selectedPlayer, { name, number });
      for (const card of __privateGet(this, _KitPersonalisation_instances, playerCards_get)) {
        const isMatch = card === btn;
        card.classList.toggle("kit-personalisation__player-card--active", isMatch);
        card.setAttribute("aria-pressed", String(isMatch));
      }
      __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    __privateAdd(this, _onTypeNavClick, (e) => {
      const btn = e.currentTarget;
      const type = btn.dataset.kitNavType;
      if (!type || type === __privateGet(this, _selectedType)) return;
      __privateSet(this, _selectedType, type);
      if (type === "special") {
        __privateMethod(this, _KitPersonalisation_instances, clearCustomInputs_fn).call(this);
        __privateMethod(this, _KitPersonalisation_instances, clearPlayerInput_fn).call(this);
      } else if (type === "player") {
        __privateMethod(this, _KitPersonalisation_instances, clearCustomInputs_fn).call(this);
        __privateMethod(this, _KitPersonalisation_instances, clearSpecialInputs_fn).call(this);
      } else {
        __privateMethod(this, _KitPersonalisation_instances, clearPlayerInput_fn).call(this);
        __privateMethod(this, _KitPersonalisation_instances, clearSpecialInputs_fn).call(this);
      }
      __privateMethod(this, _KitPersonalisation_instances, toggleFieldsForType_fn).call(this, type);
      if (type === "player") __privateMethod(this, _KitPersonalisation_instances, autoSelectDefaultPlayer_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updateTypeNav_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updateStepTitle_fn).call(this, type);
      __privateMethod(this, _KitPersonalisation_instances, showStep_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, stepForType_fn).call(this, type));
      __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
    });
    __privateAdd(this, _onFontChange, () => {
      __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updateBadgeAvailability_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    __privateAdd(this, _onBadgeClick, (e) => {
      const btn = e.currentTarget;
      if (btn.hidden || btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
      const pressed = btn.getAttribute("aria-pressed") === "true";
      if (pressed) {
        btn.setAttribute("aria-pressed", "false");
      } else {
        if (__privateMethod(this, _KitPersonalisation_instances, getSelectedBadges_fn).call(this).length >= __privateMethod(this, _KitPersonalisation_instances, badgeMax_fn).call(this)) return;
        btn.setAttribute("aria-pressed", "true");
      }
      __privateMethod(this, _KitPersonalisation_instances, updateBadgeState_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    __privateAdd(this, _onSpecialClick, (e) => {
      const btn = e.currentTarget;
      if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
      const pressed = btn.getAttribute("aria-pressed") === "true";
      btn.setAttribute("aria-pressed", pressed ? "false" : "true");
      __privateMethod(this, _KitPersonalisation_instances, updateSpecialState_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
    });
    // ── Print layout (everything relative to the artbox) ────────────────────
    /**
     * Live copy of PRINT_LAYOUT. Structured-cloned so the guides panel can
     * mutate it without editing the module-level defaults.
     * @type {typeof PRINT_LAYOUT}
     */
    __privateAdd(this, _printLayout, structuredClone(PRINT_LAYOUT));
    /** @type {Map<string, number>} */
    __privateAdd(this, _ascentRatios, /* @__PURE__ */ new Map());
    /** Whether the last layout sized accents from the artwork or from the
     *  configured value — reported by the guides panel. @type {string} */
    __privateAdd(this, _accentScaleSource, "configured");
    /** The characters already warned about as uncomparable, so a layout that
     *  re-runs on every keystroke and resize reports them once. @type {string} */
    __privateAdd(this, _unmeasuredWarned, "");
    /**
     * The letters currently drawn as artwork, or null when the name is falling
     * back to live text.
     * @type {{ char: string, src: string | null, aspect: number, height: number, accent: string }[] | null}
     */
    __privateAdd(this, _nameImageLetters, null);
    /**
     * The <image> per letter, aligned to #nameImageLetters — null where that
     * entry is a space, which takes up room but prints nothing.
     * @type {(SVGImageElement | null)[]}
     */
    __privateAdd(this, _nameImageNodes, []);
    /** What #nameImageNodes was last built for, so typing only rebuilds the
     *  nodes that actually changed. @type {string} */
    __privateAdd(this, _nameImagesKey, "");
    /** Identifies the most recent #updateNamePreview, so a slower earlier one
     *  can't overwrite it when its artwork finally loads. @type {number} */
    __privateAdd(this, _namePreviewToken, 0);
    /**
     * Measured bounding-box height per unit of font size, per font — see
     * #numberSizeForHeight.
     * @type {Map<string, number>}
     */
    __privateAdd(this, _numberEmRatio, /* @__PURE__ */ new Map());
    /** @type {SVGGElement | null} */
    __privateAdd(this, _guidesGroup, null);
    /** @type {HTMLElement | null} */
    __privateAdd(this, _guidesBand, null);
    /** @type {HTMLElement | null} */
    __privateAdd(this, _guidesReadout, null);
    /** @type {ResizeObserver | null} */
    __privateAdd(this, _guidesObserver, null);
    /** @type {HTMLElement | null} */
    __privateAdd(this, _guideSummary, null);
    /** @type {HTMLFormElement | null} */
    __privateAdd(this, _form, null);
    /** @type {string} */
    __privateAdd(this, _currentGroupKey, `kit-${Date.now()}`);
    __privateAdd(this, _onFormSubmit, (e) => {
      if (e.target !== __privateGet(this, _form)) return;
      if (!__privateMethod(this, _KitPersonalisation_instances, hasPersonalisation_fn).call(this)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      __privateMethod(this, _KitPersonalisation_instances, addPersonalisedToCart_fn).call(this, __privateGet(this, _form));
    });
    /** @type {Promise<string[]> | null} */
    __privateAdd(this, _stockCheckPromise, null);
    /** Identifies what #stockCheckPromise was started for. @type {string} */
    __privateAdd(this, _stockCheckKey, "");
  }
  connectedCallback() {
    const { signal } = __privateGet(this, _controller);
    __privateMethod(this, _KitPersonalisation_instances, parseHandles_fn).call(this);
    __privateMethod(this, _KitPersonalisation_instances, loadProducts_fn).call(this);
    __privateGet(this, _KitPersonalisation_instances, trigger_get)?.addEventListener("click", __privateGet(this, _openModal), { signal });
    for (const btn of __privateGet(this, _KitPersonalisation_instances, closeBtns_get)) {
      btn.addEventListener("click", __privateGet(this, _closeModal), { signal });
    }
    __privateGet(this, _KitPersonalisation_instances, modal_get)?.addEventListener("close", __privateGet(this, _onModalClose), { signal });
    __privateGet(this, _KitPersonalisation_instances, modal_get)?.addEventListener("cancel", __privateGet(this, _onCancel), { signal });
    __privateGet(this, _KitPersonalisation_instances, modal_get)?.addEventListener("click", __privateGet(this, _onBackdropClick), { signal });
    for (const btn of __privateGet(this, _KitPersonalisation_instances, typeButtons_get)) {
      btn.addEventListener("click", __privateGet(this, _onTypeSelect), { signal });
    }
    for (const btn of __privateGet(this, _KitPersonalisation_instances, stepBackBtns_get)) {
      btn.addEventListener("click", __privateGet(this, _onBack), { signal });
    }
    for (const btn of this.querySelectorAll("[data-kit-done]")) {
      btn.addEventListener("click", __privateGet(this, _onDoneClick), { signal });
    }
    __privateGet(this, _KitPersonalisation_instances, confirmCancelBtn_get)?.addEventListener("click", __privateGet(this, _onConfirmCancel), { signal });
    __privateGet(this, _KitPersonalisation_instances, confirmAddBtn_get)?.addEventListener("click", __privateGet(this, _onConfirmAdd), { signal });
    __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.addEventListener("input", __privateGet(this, _onNameInput), { signal });
    __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.addEventListener("keydown", __privateGet(this, _onNameKeydown), { signal });
    __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.addEventListener("input", __privateGet(this, _onNumberInput), { signal });
    __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.addEventListener("keydown", __privateGet(this, _onNumberKeydown), { signal });
    for (const btn of __privateGet(this, _KitPersonalisation_instances, categoryButtons_get)) {
      btn.addEventListener("click", __privateGet(this, _onCategoryClick), { signal });
    }
    for (const btn of __privateGet(this, _KitPersonalisation_instances, playerTabs_get)) {
      btn.addEventListener("click", __privateGet(this, _onPlayerTabClick), { signal });
    }
    for (const btn of __privateGet(this, _KitPersonalisation_instances, playerCards_get)) {
      btn.addEventListener("click", __privateGet(this, _onPlayerCardClick), { signal });
    }
    __privateMethod(this, _KitPersonalisation_instances, initPlayerCarousel_fn).call(this, signal);
    __privateMethod(this, _KitPersonalisation_instances, updateTabIndicator_fn).call(this);
    for (const btn of __privateGet(this, _KitPersonalisation_instances, typeNavItems_get)) {
      btn.addEventListener("click", __privateGet(this, _onTypeNavClick), { signal });
    }
    for (const radio of __privateGet(this, _KitPersonalisation_instances, fontRadios_get)) {
      radio.addEventListener("change", __privateGet(this, _onFontChange), { signal });
    }
    for (const btn of __privateGet(this, _KitPersonalisation_instances, badgeButtons_get)) {
      btn.addEventListener("click", __privateGet(this, _onBadgeClick), { signal });
    }
    for (const btn of __privateGet(this, _KitPersonalisation_instances, specialButtons_get)) {
      btn.addEventListener("click", __privateGet(this, _onSpecialClick), { signal });
    }
    __privateMethod(this, _KitPersonalisation_instances, interceptForm_fn).call(this, signal);
    if (__privateGet(this, _KitPersonalisation_instances, isShortsMode_get)) {
      __privateSet(this, _selectedType, "custom");
      const productColour = this.dataset.productColour;
      if (productColour) {
        const bg = COLOUR_MAP[productColour] ?? productColour;
        __privateGet(this, _KitPersonalisation_instances, previewContainer_get)?.style.setProperty("--shorts-bg", bg);
      }
    }
    __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
    __privateMethod(this, _KitPersonalisation_instances, updateBadgeAvailability_fn).call(this);
    __privateMethod(this, _KitPersonalisation_instances, applyPrintLayout_fn).call(this);
    __privateSet(this, _layoutObserver, new ResizeObserver(() => {
      __privateMethod(this, _KitPersonalisation_instances, applyPrintLayout_fn).call(this);
      __privateMethod(this, _KitPersonalisation_instances, updateGuides_fn).call(this);
    }));
    const previewContainer = __privateGet(this, _KitPersonalisation_instances, previewContainer_get);
    if (previewContainer) __privateGet(this, _layoutObserver).observe(previewContainer);
    __privateSet(this, _confirmedSnapshot, __privateMethod(this, _KitPersonalisation_instances, captureSnapshot_fn).call(this));
  }
  disconnectedCallback() {
    __privateGet(this, _controller).abort();
    if (__privateGet(this, _debounceTimer)) clearTimeout(__privateGet(this, _debounceTimer));
    __privateGet(this, _layoutObserver)?.disconnect();
    __privateGet(this, _guidesObserver)?.disconnect();
  }
}
_KitPersonalisation_instances = new WeakSet();
modal_get = function() {
  return this.querySelector("dialog");
};
trigger_get = function() {
  return this.querySelector("[data-kit-trigger]");
};
closeBtns_get = function() {
  return this.querySelectorAll("[data-kit-close]");
};
nameInput_get = function() {
  return this.querySelector("[data-kit-name]");
};
numberInput_get = function() {
  return this.querySelector("[data-kit-number]");
};
fontRadios_get = function() {
  return this.querySelectorAll(".kit-personalisation__font-radio");
};
typeButtons_get = function() {
  return this.querySelectorAll("[data-kit-type]");
};
steps_get = function() {
  return this.querySelectorAll("[data-kit-step]");
};
badgesEl_get = function() {
  return this.querySelector("[data-kit-badges]");
};
badgeButtons_get = function() {
  return this.querySelectorAll("[data-kit-badge]");
};
specialsEl_get = function() {
  return this.querySelector("[data-kit-specials]");
};
specialButtons_get = function() {
  return this.querySelectorAll("[data-kit-special]");
};
playerField_get = function() {
  return this.querySelector("[data-kit-player-field]");
};
modalBody_get = function() {
  return this.querySelector(".kit-personalisation__modal-body");
};
fieldsEl_get = function() {
  return this.querySelector(".kit-personalisation__fields");
};
categoryButtons_get = function() {
  return this.querySelectorAll("[data-kit-category]");
};
playerDropdown_get = function() {
  return this.querySelector("[data-kit-player-dropdown]");
};
playerTabs_get = function() {
  return this.querySelectorAll("[data-kit-player-tab]");
};
playerTabsList_get = function() {
  return this.querySelector("[data-kit-player-tabs]");
};
playerCardsEl_get = function() {
  return this.querySelector("[data-kit-player-cards]");
};
playerCarousel_get = function() {
  return this.querySelector("[data-kit-player-carousel]");
};
playerArrows_get = function() {
  return this.querySelectorAll("[data-kit-player-arrow]");
};
playerEmptyEl_get = function() {
  return this.querySelector("[data-kit-player-empty]");
};
playerCards_get = function() {
  return this.querySelectorAll("[data-kit-player-card]");
};
visiblePlayerCards_get = function() {
  return [...__privateGet(this, _KitPersonalisation_instances, playerCards_get)].filter((card) => !card.hidden);
};
nameField_get = function() {
  return this.querySelector("[data-kit-name]")?.closest(".kit-personalisation__field") ?? null;
};
numberField_get = function() {
  return this.querySelector("[data-kit-number]")?.closest(".kit-personalisation__field") ?? null;
};
stepBackBtns_get = function() {
  return this.querySelectorAll("[data-kit-step-back]");
};
typeNavItems_get = function() {
  return this.querySelectorAll("[data-kit-nav-type]");
};
errorEls_get = function() {
  return this.querySelectorAll("[data-kit-error]");
};
titleEl_get = function() {
  return this.querySelector("[data-kit-trigger-title]");
};
stepTitleEl_get = function() {
  return this.querySelector("[data-kit-step-title]");
};
summaryEl_get = function() {
  return this.querySelector("[data-kit-summary]");
};
subtitleEl_get = function() {
  return this.querySelector("[data-kit-trigger-subtitle]");
};
ctaLabelEl_get = function() {
  return this.querySelector("[data-kit-cta-label]");
};
previewNameTextPath_get = function() {
  return this.querySelector("[data-preview-name]");
};
previewNameStroke_get = function() {
  return this.querySelector("[data-preview-name-stroke]");
};
previewNameImages_get = function() {
  return this.querySelector("[data-preview-name-images]");
};
previewNameImageArc_get = function() {
  return this.querySelector("[data-preview-name-image-arc]");
};
previewNumber_get = function() {
  return this.querySelector("[data-preview-number]");
};
previewNumberStroke_get = function() {
  return this.querySelector("[data-preview-number-stroke]");
};
previewNumberImages_get = function() {
  return this.querySelector("[data-preview-number-images]");
};
previewContainer_get = function() {
  return this.querySelector(".kit-personalisation__preview-container");
};
previewSvg_get = function() {
  return this.querySelector(".kit-personalisation__preview-svg");
};
previewNameArc_get = function() {
  return this.querySelector(".kit-personalisation__preview-name-arc");
};
confirmOverlay_get = function() {
  return this.querySelector("[data-kit-confirm]");
};
confirmCard_get = function() {
  return this.querySelector(".kit-personalisation__confirm-card");
};
confirmBasePriceEl_get = function() {
  return this.querySelector("[data-confirm-base-price]");
};
confirmOptionsEl_get = function() {
  return this.querySelector("[data-confirm-options]");
};
confirmPersonalisationRow_get = function() {
  return this.querySelector("[data-confirm-personalisation-row]");
};
confirmPersonalisationLabelEl_get = function() {
  return this.querySelector("[data-confirm-personalisation-label]");
};
confirmPersonalisationValueEl_get = function() {
  return this.querySelector("[data-confirm-personalisation-value]");
};
confirmPersonalisationPriceEl_get = function() {
  return this.querySelector("[data-confirm-personalisation-price]");
};
confirmFontRow_get = function() {
  return this.querySelector("[data-confirm-font-row]");
};
confirmFontValueEl_get = function() {
  return this.querySelector("[data-confirm-font-value]");
};
confirmBadgesRow_get = function() {
  return this.querySelector("[data-confirm-badges-row]");
};
confirmBadgesValueEl_get = function() {
  return this.querySelector("[data-confirm-badges-value]");
};
confirmBadgesPriceEl_get = function() {
  return this.querySelector("[data-confirm-badges-price]");
};
confirmCancelBtn_get = function() {
  return this.querySelector("[data-kit-confirm-cancel]");
};
confirmAddBtn_get = function() {
  return this.querySelector("[data-kit-confirm-add]");
};
nameCountEl_get = function() {
  return this.querySelector("[data-name-count]");
};
isShortsMode_get = function() {
  return this.hasAttribute("data-shorts-mode");
};
_controller = new WeakMap();
_feeProduct = new WeakMap();
_debounceTimer = new WeakMap();
_selectedType = new WeakMap();
_selectedPlayer = new WeakMap();
_selectedCategory = new WeakMap();
_confirmedSnapshot = new WeakMap();
_confirmed = new WeakMap();
_layoutObserver = new WeakMap();
_lettersHandles = new WeakMap();
_numbersHandles = new WeakMap();
_variantsById = new WeakMap();
_optionNames = new WeakMap();
parseHandles_fn = function() {
  try {
    __privateSet(this, _lettersHandles, JSON.parse(this.dataset.lettersHandles || "[]"));
  } catch {
    __privateSet(this, _lettersHandles, []);
  }
  try {
    __privateSet(this, _numbersHandles, JSON.parse(this.dataset.numbersHandles || "[]"));
  } catch {
    __privateSet(this, _numbersHandles, []);
  }
  try {
    __privateSet(this, _variantsById, JSON.parse(this.dataset.variants || "{}"));
  } catch {
    __privateSet(this, _variantsById, {});
  }
  try {
    __privateSet(this, _optionNames, JSON.parse(this.dataset.optionNames || "[]"));
  } catch {
    __privateSet(this, _optionNames, []);
  }
};
loadProducts_fn = async function() {
  const feeHandle = this.dataset.feeHandle;
  if (feeHandle) {
    try {
      __privateSet(this, _feeProduct, await fetchProduct(feeHandle));
    } catch (err) {
      console.error("[kit-personalisation] Failed to load fee product:", err);
    }
  }
};
/**
 * Get the letter and number product handles for the selected font.
 *
 * @param {string} font - Font label (e.g. "Premier League")
 * @returns {{ lettersHandle: string | undefined, numbersHandle: string | undefined }}
 */
handlesForFont_fn = function(font) {
  const fontKey = FONT_HANDLE_KEY[font];
  if (!fontKey) return { lettersHandle: void 0, numbersHandle: void 0 };
  return {
    lettersHandle: findHandleForFont(__privateGet(this, _lettersHandles), fontKey),
    numbersHandle: findHandleForFont(__privateGet(this, _numbersHandles), fontKey)
  };
};
// ── Step navigation ─────────────────────────────────────────────────────
/**
 * Map a selected type to its step name.
 *
 * @param {string | null} type
 * @returns {string}
 */
stepForType_fn = function(type) {
  return type === "special" ? "special" : "details";
};
/**
 * Updates the shared step title (matches step 1's) to reflect the
 * selected personalisation type. Falls back to its own current text if
 * the expected data attribute isn't present.
 *
 * @param {string | null} type
 */
updateStepTitle_fn = function(type) {
  const el = __privateGet(this, _KitPersonalisation_instances, stepTitleEl_get);
  if (!el) return;
  if (type === "player") {
    el.textContent = el.dataset.titlePlayer ?? el.textContent;
  } else if (type === "custom") {
    el.textContent = el.dataset.titleCustom ?? el.textContent;
  } else if (type === "special") {
    el.textContent = el.dataset.titleSpecial ?? el.textContent;
  } else {
    el.textContent = el.dataset.titleDefault ?? el.textContent;
  }
};
/**
 * Show a single step and toggle the footer (shown on every step except the
 * type-selection step).
 *
 * @param {string} name - "type" | "details" | "special"
 */
showStep_fn = function(name) {
  for (const step of __privateGet(this, _KitPersonalisation_instances, steps_get)) {
    if (step.dataset.kitStep === name) {
      __privateMethod(this, _KitPersonalisation_instances, cancelStepExit_fn).call(this, step);
      step.hidden = false;
    } else if (!step.hidden) {
      __privateMethod(this, _KitPersonalisation_instances, exitStep_fn).call(this, step);
    }
  }
  const modal = __privateGet(this, _KitPersonalisation_instances, modal_get);
  if (modal) modal.dataset.step = name;
  __privateGet(this, _KitPersonalisation_instances, modalBody_get)?.scrollTo(0, 0);
  __privateGet(this, _KitPersonalisation_instances, fieldsEl_get)?.scrollTo(0, 0);
  if (__privateGet(this, _KitPersonalisation_instances, isShortsMode_get)) {
    for (const btn of __privateGet(this, _KitPersonalisation_instances, stepBackBtns_get)) {
      btn.hidden = true;
    }
  }
  requestAnimationFrame(__privateGet(this, _updateCarouselArrows));
};
_stepExitTimers = new WeakMap();
/**
 * Runs the leaving animation on a step, then hides it. The class is what
 * drives the reverse keyframes (see __step--exiting in the stylesheet); it
 * also takes the step out of flow so it can overlap the incoming one.
 *
 * @param {HTMLElement} step
 */
exitStep_fn = function(step) {
  step.classList.add("kit-personalisation__step--exiting");
  const finish = () => {
    step.classList.remove("kit-personalisation__step--exiting");
    step.hidden = true;
    __privateGet(this, _stepExitTimers).delete(step);
  };
  clearTimeout(__privateGet(this, _stepExitTimers).get(step));
  __privateGet(this, _stepExitTimers).set(step, setTimeout(finish, STEP_EXIT_DURATION));
};
/**
 * Stops a pending exit — the customer has come back to this step before it
 * finished leaving, so it must not hide itself out from under them.
 *
 * @param {HTMLElement} step
 */
cancelStepExit_fn = function(step) {
  clearTimeout(__privateGet(this, _stepExitTimers).get(step));
  __privateGet(this, _stepExitTimers).delete(step);
  step.classList.remove("kit-personalisation__step--exiting");
};
_openModal = new WeakMap();
_closeModal = new WeakMap();
_onDoneClick = new WeakMap();
/**
 * Populates the "Your order" summary (shirt + variant, personalisation
 * fee or special edition, sleeve badges) from the current selections and
 * reveals it over the panel.
 */
openConfirmOverlay_fn = function() {
  const overlay = __privateGet(this, _KitPersonalisation_instances, confirmOverlay_get);
  if (!overlay || !__privateGet(this, _form)) return;
  __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
  const formData = new FormData(__privateGet(this, _form));
  const variant = __privateGet(this, _variantsById)[String(formData.get("id"))];
  if (__privateGet(this, _KitPersonalisation_instances, confirmBasePriceEl_get)) {
    __privateGet(this, _KitPersonalisation_instances, confirmBasePriceEl_get).textContent = variant ? __privateMethod(this, _KitPersonalisation_instances, formatMoney_fn).call(this, variant.price) : "";
  }
  const optionsEl = __privateGet(this, _KitPersonalisation_instances, confirmOptionsEl_get);
  if (optionsEl) {
    optionsEl.replaceChildren();
    if (variant) {
      __privateGet(this, _optionNames).forEach((name, i) => {
        const value = variant[`option${i + 1}`];
        if (!name || !value) return;
        const item = document.createElement("div");
        item.className = "kit-personalisation__confirm-subrow-item";
        const label = document.createElement("span");
        label.className = "kit-personalisation__confirm-label";
        label.textContent = name;
        const val = document.createElement("span");
        val.className = "kit-personalisation__confirm-value";
        val.textContent = value;
        item.append(label, val);
        optionsEl.append(item);
      });
    }
  }
  if (__privateGet(this, _selectedType) === "special") {
    const specials = __privateMethod(this, _KitPersonalisation_instances, getSelectedSpecials_fn).call(this);
    const total = specials.reduce((sum, s) => sum + s.price, 0);
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationRow_get)) __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationRow_get).hidden = specials.length === 0;
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabelEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabelEl_get).textContent = __privateGet(this, _KitPersonalisation_instances, confirmSpecialLabel_get);
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationValueEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationValueEl_get).textContent = specials.map((s) => s.title).join(", ") || __privateGet(this, _KitPersonalisation_instances, confirmNoneLabel_get);
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationPriceEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationPriceEl_get).textContent = __privateMethod(this, _KitPersonalisation_instances, formatAddOnPrice_fn).call(this, total);
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmFontRow_get)) __privateGet(this, _KitPersonalisation_instances, confirmFontRow_get).hidden = true;
    if (__privateGet(this, _KitPersonalisation_instances, confirmBadgesRow_get)) __privateGet(this, _KitPersonalisation_instances, confirmBadgesRow_get).hidden = true;
  } else {
    const name = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerName_fn).call(this) || __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value.trim().toUpperCase() || "";
    const number = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerNumber_fn).call(this) || __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value.trim() || "";
    const hasNameOrNumber = __privateMethod(this, _KitPersonalisation_instances, hasNameOrNumber_fn).call(this);
    const feeVariant = __privateGet(this, _feeProduct) ? findFeeVariant(__privateGet(this, _feeProduct).variants) : void 0;
    const feePrice = hasNameOrNumber && feeVariant ? feeVariant.price : 0;
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationRow_get)) __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationRow_get).hidden = !hasNameOrNumber;
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabelEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabelEl_get).textContent = __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabel_get);
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationValueEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationValueEl_get).textContent = [name, number].filter(Boolean).join(" ");
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmPersonalisationPriceEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationPriceEl_get).textContent = __privateMethod(this, _KitPersonalisation_instances, formatAddOnPrice_fn).call(this, feePrice);
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmFontRow_get)) __privateGet(this, _KitPersonalisation_instances, confirmFontRow_get).hidden = !hasNameOrNumber;
    if (__privateGet(this, _KitPersonalisation_instances, confirmFontValueEl_get)) __privateGet(this, _KitPersonalisation_instances, confirmFontValueEl_get).textContent = __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this);
    const badges = __privateMethod(this, _KitPersonalisation_instances, getSelectedBadges_fn).call(this);
    const badgesTotal = badges.reduce((sum, b) => sum + b.price, 0);
    if (__privateGet(this, _KitPersonalisation_instances, confirmBadgesRow_get)) __privateGet(this, _KitPersonalisation_instances, confirmBadgesRow_get).hidden = false;
    if (__privateGet(this, _KitPersonalisation_instances, confirmBadgesValueEl_get)) {
      __privateGet(this, _KitPersonalisation_instances, confirmBadgesValueEl_get).textContent = badges.length ? badges.map((b) => b.title).join(", ") : __privateGet(this, _KitPersonalisation_instances, confirmNoneLabel_get);
    }
    if (__privateGet(this, _KitPersonalisation_instances, confirmBadgesPriceEl_get)) __privateGet(this, _KitPersonalisation_instances, confirmBadgesPriceEl_get).textContent = __privateMethod(this, _KitPersonalisation_instances, formatAddOnPrice_fn).call(this, badgesTotal);
  }
  overlay.hidden = false;
  __privateMethod(this, _KitPersonalisation_instances, prewarmStockCheck_fn).call(this);
  overlay.offsetHeight;
  overlay.classList.add("kit-personalisation__confirm--open");
};
/**
 * Reverses the pop-up animation (card slides back down, fades out) before
 * hiding the overlay, rather than snapping it away instantly.
 */
closeConfirmOverlay_fn = function() {
  const overlay = __privateGet(this, _KitPersonalisation_instances, confirmOverlay_get);
  const card = __privateGet(this, _KitPersonalisation_instances, confirmCard_get);
  if (!overlay) return;
  overlay.classList.remove("kit-personalisation__confirm--open");
  const onEnd = (e) => {
    if (e.target !== card) return;
    card?.removeEventListener("transitionend", onEnd);
    overlay.hidden = true;
  };
  card?.addEventListener("transitionend", onEnd);
  setTimeout(() => {
    overlay.hidden = true;
  }, 350);
};
_onConfirmCancel = new WeakMap();
_onConfirmAdd = new WeakMap();
confirmPersonalisationLabel_get = function() {
  return __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabelEl_get)?.dataset.labelDefault ?? "Personalisation";
};
confirmSpecialLabel_get = function() {
  return __privateGet(this, _KitPersonalisation_instances, confirmPersonalisationLabelEl_get)?.dataset.labelSpecial ?? "Special edition";
};
confirmNoneLabel_get = function() {
  return __privateGet(this, _KitPersonalisation_instances, confirmBadgesValueEl_get)?.dataset.none ?? "None";
};
/**
 * @param {number} cents
 * @returns {string}
 */
formatMoney_fn = function(cents) {
  return formatMoney(cents, this.dataset.moneyFormat || "${{amount}}", this.dataset.currency || "GBP");
};
/**
 * @param {number} cents
 * @returns {string}
 */
formatAddOnPrice_fn = function(cents) {
  return `+ ${__privateMethod(this, _KitPersonalisation_instances, formatMoney_fn).call(this, cents)}`;
};
_onTypeSelect = new WeakMap();
/**
 * Pre-selects the first squad the first time the player flow is
 * entered, revealing the player picker — but leaves the player itself
 * unselected, so the shirt preview stays blank until the user picks one.
 * Runs synchronously (rather than after a delay) so the picker's height
 * is already settled before the section's own entrance animation plays —
 * revealing it later, mid-animation, made the layout below jump as it
 * suddenly grew. Does nothing if a player is already selected (e.g. the
 * user picked one, switched type, then switched back).
 */
autoSelectDefaultPlayer_fn = function() {
  if (__privateGet(this, _selectedPlayer)) return;
  const categoryBtn = __privateGet(this, _KitPersonalisation_instances, categoryButtons_get)[0];
  const category = categoryBtn?.dataset.kitCategory;
  if (!categoryBtn || !category) {
    const dropdown = __privateGet(this, _KitPersonalisation_instances, playerDropdown_get);
    if (dropdown) dropdown.hidden = false;
    __privateMethod(this, _KitPersonalisation_instances, filterPlayerCards_fn).call(this);
    return;
  }
  __privateMethod(this, _KitPersonalisation_instances, selectCategory_fn).call(this, categoryBtn, category);
};
/**
 * Marks the given squad button active, reveals the player picker and
 * re-filters the roster to that squad. Shared by the auto-selected
 * default squad and manual squad clicks — callers decide separately
 * whether to touch the current player selection.
 */
selectCategory_fn = function(btn, category) {
  __privateSet(this, _selectedCategory, category);
  for (const b of __privateGet(this, _KitPersonalisation_instances, categoryButtons_get)) {
    b.classList.toggle("kit-personalisation__category-btn--active", b === btn);
  }
  const dropdown = __privateGet(this, _KitPersonalisation_instances, playerDropdown_get);
  if (dropdown) dropdown.hidden = false;
  __privateMethod(this, _KitPersonalisation_instances, filterPlayerCards_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updateBadgeAvailability_fn).call(this);
};
/**
 * Clicks the first player card still passing the current filters — used to
 * keep a card selected (and the shirt preview populated) whenever the
 * available set changes, e.g. on initial reveal or after switching
 * squad/position.
 */
selectFirstVisiblePlayerCard_fn = function() {
  __privateGet(this, _KitPersonalisation_instances, visiblePlayerCards_get)[0]?.click();
};
// ── Player filtering (squad + position) ─────────────────────────────────
/** @returns {string} The handleized position of the active tab, or "all". */
activePosition_fn = function() {
  const tab = [...__privateGet(this, _KitPersonalisation_instances, playerTabs_get)].find((t) => t.getAttribute("aria-selected") === "true");
  return tab?.dataset.kitPlayerTab ?? "all";
};
/**
 * The roster is rendered once as a flat list of cards carrying
 * `data-player-category` / `data-player-position` from the metaobject;
 * both filters are applied here by toggling `hidden` rather than by
 * duplicating cards into a panel per squad/position combination.
 *
 * Position tabs with no players in the selected squad are hidden too, and
 * if the active tab is one of them the filter falls back to "All" so the
 * customer is never left staring at an empty carousel.
 */
filterPlayerCards_fn = function() {
  const category = __privateGet(this, _selectedCategory);
  const cardsInCategory = [...__privateGet(this, _KitPersonalisation_instances, playerCards_get)].filter(
    (card) => !category || card.dataset.playerCategory === category
  );
  const availablePositions = new Set(
    cardsInCategory.map((card) => card.dataset.playerPosition).filter(Boolean)
  );
  for (const tab of __privateGet(this, _KitPersonalisation_instances, playerTabs_get)) {
    const position2 = tab.dataset.kitPlayerTab;
    tab.hidden = position2 !== "all" && !availablePositions.has(position2);
  }
  let position = __privateMethod(this, _KitPersonalisation_instances, activePosition_fn).call(this);
  const activeTab = [...__privateGet(this, _KitPersonalisation_instances, playerTabs_get)].find((t) => t.dataset.kitPlayerTab === position);
  if (activeTab?.hidden) {
    const allTab = [...__privateGet(this, _KitPersonalisation_instances, playerTabs_get)].find((t) => t.dataset.kitPlayerTab === "all");
    if (allTab) {
      __privateMethod(this, _KitPersonalisation_instances, activateTab_fn).call(this, allTab);
      position = "all";
    }
  }
  for (const card of __privateGet(this, _KitPersonalisation_instances, playerCards_get)) {
    const matchesCategory = !category || card.dataset.playerCategory === category;
    const matchesPosition = position === "all" || card.dataset.playerPosition === position;
    card.hidden = !(matchesCategory && matchesPosition);
  }
  const emptyEl = __privateGet(this, _KitPersonalisation_instances, playerEmptyEl_get);
  const visible = __privateGet(this, _KitPersonalisation_instances, visiblePlayerCards_get).length;
  if (emptyEl) emptyEl.hidden = visible > 0;
  const carousel = __privateGet(this, _KitPersonalisation_instances, playerCarousel_get);
  if (carousel) carousel.hidden = visible === 0;
  __privateMethod(this, _KitPersonalisation_instances, updateTabIndicator_fn).call(this);
  __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get)?.scrollTo({ left: 0, behavior: "auto" });
  __privateGet(this, _updateCarouselArrows).call(this);
};
/**
 * Marks a tab active (aria + roving tabindex) and points the panel's
 * label at it. Selection state only — filtering is done by the caller.
 *
 * @param {HTMLButtonElement} tab
 */
activateTab_fn = function(tab) {
  for (const t of __privateGet(this, _KitPersonalisation_instances, playerTabs_get)) {
    const active = t === tab;
    t.setAttribute("aria-selected", String(active));
    t.tabIndex = active ? 0 : -1;
  }
  const panel = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
  if (panel && tab.id) panel.setAttribute("aria-labelledby", tab.id);
};
/**
 * Sliding active-tab indicator (matches the PDP's product-tabs): width is
 * driven by the *visible* tab count, position by the active tab's index
 * among them — both set as custom properties, no JS pixel measurement.
 * Recomputed on every filter change because hiding a tab changes both.
 */
updateTabIndicator_fn = function() {
  const list = __privateGet(this, _KitPersonalisation_instances, playerTabsList_get);
  if (!list) return;
  const visibleTabs = [...__privateGet(this, _KitPersonalisation_instances, playerTabs_get)].filter((t) => !t.hidden);
  if (visibleTabs.length === 0) return;
  const activeTab = visibleTabs.find((t) => t.getAttribute("aria-selected") === "true");
  const index = activeTab ? visibleTabs.indexOf(activeTab) : 0;
  list.style.setProperty("--kit-player-tabs-count", String(visibleTabs.length));
  list.style.setProperty("--kit-player-tabs-active-index", String(index));
};
toggleFieldsForType_fn = function(type) {
  const playerField = __privateGet(this, _KitPersonalisation_instances, playerField_get);
  const nameField = __privateGet(this, _KitPersonalisation_instances, nameField_get);
  const numberField = __privateGet(this, _KitPersonalisation_instances, numberField_get);
  const nameCount = __privateGet(this, _KitPersonalisation_instances, nameCountEl_get);
  const badgesEl = __privateGet(this, _KitPersonalisation_instances, badgesEl_get);
  if (type === "player") {
    if (playerField) playerField.hidden = false;
    if (nameField) nameField.hidden = true;
    if (numberField) numberField.hidden = true;
    if (nameCount) nameCount.hidden = true;
    if (badgesEl) badgesEl.hidden = false;
  } else {
    if (playerField) playerField.hidden = true;
    if (nameField) nameField.hidden = false;
    if (numberField) numberField.hidden = false;
    if (nameCount) nameCount.hidden = false;
    if (badgesEl) badgesEl.hidden = false;
  }
  __privateMethod(this, _KitPersonalisation_instances, updateBadgeAvailability_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updateTypeNav_fn).call(this);
};
_onBack = new WeakMap();
_onModalClose = new WeakMap();
_onCancel = new WeakMap();
_onBackdropClick = new WeakMap();
_onNameInput = new WeakMap();
_onNameKeydown = new WeakMap();
_onNumberInput = new WeakMap();
_onNumberKeydown = new WeakMap();
_onCategoryClick = new WeakMap();
_onPlayerTabClick = new WeakMap();
_isDraggingPlayers = new WeakMap();
_playerDragStart = new WeakMap();
/**
 * The card row scrolls horizontally, which isn't obvious with a hidden
 * scrollbar and a trackpad — so on pointer devices it also gets hover
 * arrows and click-and-drag scrolling. Touch is left alone: swiping the
 * row already works natively, and hijacking pointer events there would
 * fight the browser's own momentum scrolling.
 *
 * @param {AbortSignal} signal
 */
initPlayerCarousel_fn = function(signal) {
  const scroller = __privateGet(this, _KitPersonalisation_instances, playerCardsEl_get);
  if (!scroller) return;
  for (const btn of __privateGet(this, _KitPersonalisation_instances, playerArrows_get)) {
    btn.addEventListener("click", __privateGet(this, _onPlayerArrowClick), { signal });
  }
  scroller.addEventListener("scroll", __privateGet(this, _updateCarouselArrows), { signal, passive: true });
  window.addEventListener("resize", __privateGet(this, _updateCarouselArrows), { signal, passive: true });
  scroller.addEventListener("pointerdown", __privateGet(this, _onPlayerPointerDown), { signal });
  scroller.addEventListener("pointermove", __privateGet(this, _onPlayerPointerMove), { signal });
  scroller.addEventListener("pointerup", __privateGet(this, _onPlayerPointerUp), { signal });
  scroller.addEventListener("pointercancel", __privateGet(this, _onPlayerPointerUp), { signal });
  scroller.addEventListener("click", __privateGet(this, _onPlayerCardsClickCapture), { capture: true, signal });
  scroller.addEventListener("dragstart", (e) => e.preventDefault(), { signal });
};
_updateCarouselArrows = new WeakMap();
_onPlayerArrowClick = new WeakMap();
_onPlayerPointerDown = new WeakMap();
_onPlayerPointerMove = new WeakMap();
_onPlayerPointerUp = new WeakMap();
_onPlayerCardsClickCapture = new WeakMap();
_onPlayerCardClick = new WeakMap();
_onTypeNavClick = new WeakMap();
updateTypeNav_fn = function() {
  for (const btn of __privateGet(this, _KitPersonalisation_instances, typeNavItems_get)) {
    btn.classList.toggle(
      "kit-personalisation__type-nav-item--active",
      btn.dataset.kitNavType === __privateGet(this, _selectedType)
    );
  }
};
getSelectedPlayerName_fn = function() {
  return __privateGet(this, _selectedPlayer)?.name ?? "";
};
getSelectedPlayerNumber_fn = function() {
  return __privateGet(this, _selectedPlayer)?.number ?? "";
};
_onFontChange = new WeakMap();
// ── Sleeve badges ───────────────────────────────────────────────────────
/**
 * @returns {number} Maximum number of badges the customer can add.
 */
badgeMax_fn = function() {
  return Number(__privateGet(this, _KitPersonalisation_instances, badgesEl_get)?.dataset.badgeMax) || 2;
};
/**
 * @returns {{ id: number, title: string, price: number }[]}
 */
getSelectedBadges_fn = function() {
  return [...__privateGet(this, _KitPersonalisation_instances, badgeButtons_get)].filter((btn) => btn.getAttribute("aria-pressed") === "true").map((btn) => ({
    id: Number(btn.dataset.badgeId),
    title: btn.dataset.badgeTitle ?? "",
    price: Number(btn.dataset.badgePrice) || 0
  }));
};
/**
 * The axes a sleeve badge can be restricted along, paired with what the
 * customer has currently chosen on each. A badge is offered when every
 * axis passes; an axis passes when the badge places no restriction on it,
 * or when nothing is selected on that axis for the badge to conflict with.
 *
 * Adding a third axis later (junior/adult is the obvious one — the element
 * already carries `data-age-group`) is a row here plus the matching
 * attribute in the Liquid.
 *
 * @returns {{ attr: string, value: string, normalise: (v: string) => string }[]}
 */
badgeRules_fn = function() {
  const squad = __privateGet(this, _selectedType) === "player" ? __privateGet(this, _selectedCategory) : "";
  return [
    { attr: "badgeFonts", value: toFontKey(__privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this)), normalise: toFontKey },
    { attr: "badgeSquads", value: normaliseKey(squad), normalise: normaliseKey }
  ];
};
/**
 * Show only the badges the current font and squad allow, dropping any
 * already-selected badge that the latest change has ruled out.
 *
 * Disallowed badges are hidden rather than disabled: a greyed-out badge
 * with no way to explain itself reads as broken stock. Deselecting one
 * silently would read as a bug too — the customer chose it and watched it
 * vanish — so anything removed is named in the error region.
 */
updateBadgeAvailability_fn = function() {
  const container = __privateGet(this, _KitPersonalisation_instances, badgesEl_get);
  if (!container) return;
  const rules = __privateMethod(this, _KitPersonalisation_instances, badgeRules_fn).call(this);
  const removed = [];
  for (const btn of __privateGet(this, _KitPersonalisation_instances, badgeButtons_get)) {
    const allowed = rules.every((rule) => {
      const restriction = btn.dataset[rule.attr];
      if (!restriction || !rule.value) return true;
      return restriction.split(",").map(rule.normalise).includes(rule.value);
    });
    btn.classList.toggle(BADGE_UNAVAILABLE_CLASS, !allowed);
    if (!allowed) btn.setAttribute("aria-disabled", "true");
    if (!allowed && btn.getAttribute("aria-pressed") === "true") {
      btn.setAttribute("aria-pressed", "false");
      removed.push(btn.dataset.badgeTitle ?? "");
    }
  }
  __privateMethod(this, _KitPersonalisation_instances, updateBadgeState_fn).call(this);
  if (removed.length) {
    __privateMethod(this, _KitPersonalisation_instances, showError_fn).call(this, `${removed.join(", ")} \u2014 not available with this selection, so removed from your kit.`);
    __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
  }
};
_onBadgeClick = new WeakMap();
/**
 * Lock unselected badges once the max is reached.
 */
updateBadgeState_fn = function() {
  const container = __privateGet(this, _KitPersonalisation_instances, badgesEl_get);
  if (!container) return;
  const max = __privateMethod(this, _KitPersonalisation_instances, badgeMax_fn).call(this);
  const selected = __privateMethod(this, _KitPersonalisation_instances, getSelectedBadges_fn).call(this).length;
  const atMax = selected >= max;
  for (const btn of __privateGet(this, _KitPersonalisation_instances, badgeButtons_get)) {
    if (btn.disabled || btn.classList.contains(BADGE_UNAVAILABLE_CLASS)) continue;
    const isSelected = btn.getAttribute("aria-pressed") === "true";
    if (!isSelected && atMax) {
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("kit-personalisation__badge-option--locked");
    } else {
      btn.removeAttribute("aria-disabled");
      btn.classList.remove("kit-personalisation__badge-option--locked");
    }
  }
};
// ── Special editions ────────────────────────────────────────────────────
/**
 * @returns {{ id: number, title: string, price: number }[]}
 */
getSelectedSpecials_fn = function() {
  return [...__privateGet(this, _KitPersonalisation_instances, specialButtons_get)].filter((btn) => btn.getAttribute("aria-pressed") === "true").map((btn) => ({
    id: Number(btn.dataset.specialId),
    title: btn.dataset.specialTitle ?? "",
    price: Number(btn.dataset.specialPrice) || 0
  }));
};
_onSpecialClick = new WeakMap();
/**
 * Update the special-editions counter.
 */
updateSpecialState_fn = function() {
  const container = __privateGet(this, _KitPersonalisation_instances, specialsEl_get);
  if (!container) return;
  const selected = __privateMethod(this, _KitPersonalisation_instances, getSelectedSpecials_fn).call(this).length;
  const countEl = container.querySelector("[data-special-count]");
  if (countEl) countEl.textContent = `${selected} selected`;
};
// ── Preview ─────────────────────────────────────────────────────────────
debouncedPreview_fn = function() {
  if (__privateGet(this, _debounceTimer)) clearTimeout(__privateGet(this, _debounceTimer));
  __privateSet(this, _debounceTimer, setTimeout(() => __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this), 150));
};
getSelectedFont_fn = function() {
  for (const radio of __privateGet(this, _KitPersonalisation_instances, fontRadios_get)) {
    if (radio.checked) return radio.value;
  }
  return "";
};
_printLayout = new WeakMap();
/**
 * How far the glyphs rise above the alphabetic baseline, per unit of font
 * size, for the given font. This is what top-anchors the print: placing a
 * baseline at `desiredTop + ascent` puts the glyph tops on `desiredTop`,
 * doing the job dominant-baseline: hanging would otherwise do — but doing
 * it arithmetically, so it behaves the same in every engine.
 *
 * Measured with a throwaway <text> probe carrying the preview's own class,
 * so it picks up whichever of the three fonts is selected.
 *
 * @param {string} font
 * @returns {number}
 */
ascentRatio_fn = function(font) {
  const cached = __privateGet(this, _ascentRatios).get(font);
  if (cached !== void 0) return cached;
  const svg = __privateGet(this, _KitPersonalisation_instances, previewSvg_get);
  if (!svg) return ASCENT_RATIO_FALLBACK;
  const probe = document.createElementNS("http://www.w3.org/2000/svg", "text");
  probe.setAttribute("class", "kit-personalisation__preview-number");
  probe.setAttribute("x", "0");
  probe.setAttribute("y", "0");
  probe.setAttribute("visibility", "hidden");
  probe.style.fontSize = `${NUMBER_MEASURE_SIZE}px`;
  probe.textContent = "HX0";
  svg.append(probe);
  let ratio = ASCENT_RATIO_FALLBACK;
  try {
    const box = probe.getBBox();
    if (box.height > 0) ratio = -box.y / NUMBER_MEASURE_SIZE;
  } catch {
  }
  probe.remove();
  if (ratio !== ASCENT_RATIO_FALLBACK) __privateGet(this, _ascentRatios).set(font, ratio);
  return ratio;
};
_ascentRatios = new WeakMap();
/**
 * The artbox in viewBox user units.
 * @returns {{ x: number, y: number, width: number, height: number }}
 */
artboxUnits_fn = function() {
  const a = __privateGet(this, _printLayout).artbox;
  return {
    x: a.x / 100 * VIEWBOX_SIZE,
    y: a.y / 100 * VIEWBOX_SIZE,
    width: a.width / 100 * VIEWBOX_SIZE,
    height: a.height / 100 * VIEWBOX_SIZE
  };
};
/**
 * Derives the name arc, the number's position and size, and the digit
 * image band from the artbox, then applies them.
 *
 * This replaces what used to be fixed coordinates in Liquid and CSS with
 * one relative definition: the arc's `d`, the number's `y`/`font-size` and
 * the digit band's box are all computed here, so there's nothing
 * breakpoint-specific left to keep in sync.
 */
/**
 * The name arc. It's the name's TOP edge conceptually, but the path itself
 * is the alphabetic baseline the text sits on — so it's drawn one ascent
 * lower than the requested top.
 *
 * Kept separate from the rest of the layout because the offset depends on
 * the name's font size, which isn't known until the name has been fitted to
 * the arc. That isn't circular: the offset is a pure vertical translation
 * and translating a path doesn't change its length, so the fitted size
 * stays valid and one pass is exact.
 *
 * @param {number} nameSize - Font size in viewBox units
 */
applyNameArc_fn = function(nameSize) {
  const arc = __privateGet(this, _KitPersonalisation_instances, previewNameArc_get);
  if (!arc) return;
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  const { name } = __privateGet(this, _printLayout);
  const inset = name.inset / 100 * ab.width;
  const topY = ab.y + name.top / 100 * ab.height;
  const baselineY = topY + __privateMethod(this, _KitPersonalisation_instances, ascentRatio_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this)) * nameSize;
  const depth = name.curveDepth / 100 * ab.width;
  const x1 = ab.x + inset;
  const x2 = ab.x + ab.width - inset;
  const d = `M ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, x1)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, baselineY)} Q ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, ab.x + ab.width / 2)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, baselineY - depth)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, x2)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, baselineY)}`;
  arc.setAttribute("d", d);
  arc.style.removeProperty("d");
};
/**
 * The arc the letter artwork hangs from. Same curve as the text arc —
 * same inset, same depth — but it IS the top edge rather than a baseline
 * one ascent below it, because artwork has no ascent to measure.
 *
 * Kept as its own path element so both can exist at once: the text arc's
 * offset moves with the name's font size, and the two would otherwise
 * fight over a single `d`.
 */
applyNameImageArc_fn = function() {
  const arc = __privateGet(this, _KitPersonalisation_instances, previewNameImageArc_get);
  if (!arc) return;
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  const { name } = __privateGet(this, _printLayout);
  const inset = name.inset / 100 * ab.width;
  const topY = ab.y + name.image.top / 100 * ab.height;
  const depth = name.curveDepth / 100 * ab.width;
  const x1 = ab.x + inset;
  const x2 = ab.x + ab.width - inset;
  arc.setAttribute(
    "d",
    `M ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, x1)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, topY)} Q ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, ab.x + ab.width / 2)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, topY - depth)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, x2)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, topY)}`
  );
  arc.style.removeProperty("d");
};
/**
 * Lays the letter artwork out along the image arc: each letter is sized
 * from its own aspect ratio, then placed at its centre point on the curve
 * and rotated to the tangent there, so the word bends with the arc the
 * same way `textPath` bends the live text.
 *
 * Unlike the digit band this stays in the SVG's own coordinate system, so
 * there's no pixel mapping to redo — the letters are laid out in viewBox
 * units and scale with everything else. It still has to re-run on resize
 * (through #applyPrintLayout) because the artbox it's derived from does.
 */
layoutNameImages_fn = function() {
  const group = __privateGet(this, _KitPersonalisation_instances, previewNameImages_get);
  const arc = __privateGet(this, _KitPersonalisation_instances, previewNameImageArc_get);
  const letters = __privateGet(this, _nameImageLetters);
  if (!group || !arc || !letters?.length) return;
  __privateMethod(this, _KitPersonalisation_instances, applyNameImageArc_fn).call(this);
  let arcLength = 0;
  try {
    arcLength = arc.getTotalLength();
  } catch {
  }
  if (!arcLength) return;
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  const cfg = __privateGet(this, _printLayout).name.image;
  const bodyBox = __privateMethod(this, _KitPersonalisation_instances, bodyBoxesFor_fn).call(this, letters);
  const advancePerHeight = letters.reduce((sum, letter) => sum + letter.aspect / bodyBox(letter).fraction, 0) + (letters.length - 1) * (cfg.gap / 100);
  if (advancePerHeight <= 0) return;
  const height = Math.min(
    cfg.maxHeight / 100 * ab.height,
    arcLength * cfg.fill / advancePerHeight
  );
  const gap = cfg.gap / 100 * height;
  const total = advancePerHeight * height;
  let offset = (arcLength - total) / 2;
  for (const [index, letter] of letters.entries()) {
    const box = bodyBox(letter);
    const letterHeight = height / box.fraction;
    const width = letter.aspect * letterHeight;
    const centre = offset + width / 2;
    offset += width + gap;
    const node = __privateGet(this, _nameImageNodes)[index];
    if (!node) continue;
    const at = (length) => arc.getPointAtLength(Math.min(arcLength, Math.max(0, length)));
    const before = at(centre - TANGENT_SAMPLE);
    const after = at(centre + TANGENT_SAMPLE);
    const point = at(centre);
    const angle = Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI;
    const top = -box.top * letterHeight;
    node.setAttribute("x", String(__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, -width / 2)));
    node.setAttribute("y", String(__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, top)));
    node.setAttribute("width", String(__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, width)));
    node.setAttribute("height", String(__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, letterHeight)));
    node.setAttribute(
      "transform",
      `translate(${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, point.x)} ${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, point.y)}) rotate(${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, angle)})`
    );
  }
};
/**
 * Where each letter's BODY sits within its artwork, so every body can be
 * drawn at the same height whatever the sheet's export convention.
 *
 * Derived by comparing an accented letter against its own base letter, both
 * of which are on the sheet. The sheets draw É by scaling the whole glyph
 * down to fit the standard canvas and tight-cropping it, so É comes out
 * narrower than E by exactly the proportion the accent stole from its
 * height — 82x200 against 105x200 on the current sheet. Dividing the two
 * aspect ratios recovers that proportion:
 *
 *     fraction = aspect(É) / aspect(E) = 0.410 / 0.525 = 0.781
 *
 * which puts the body's top edge at row 44 of 200 — where reading the
 * artwork's pixels also puts it, without needing to read any.
 *
 * Being a ratio of ratios it carries no units, so the sheets can be
 * exported at any resolution, and it works on one fixed canvas height for
 * every character, which is how these sheets are actually produced.
 *
 * Falls back to a box synthesised from the configured accentScale when the
 * base letter has no artwork of its own to compare against.
 *
 * @param {{ height: number, accent: string, body: object | null }[]} letters
 * @returns {(letter: object) => { top: number, fraction: number }}
 */
bodyBoxesFor_fn = function(letters) {
  const configured = __privateGet(this, _printLayout).name.image.accentScale;
  const accented = letters.filter((letter) => letter.src && letter.accent !== "none");
  const comparable = accented.filter((letter) => letter.baseAspect > 0 && letter.aspect > 0);
  __privateSet(this, _accentScaleSource, !accented.length ? "n/a" : comparable.length === accented.length ? "measured" : comparable.length ? "part-measured" : "estimated");
  if (accented.length > comparable.length) {
    const missing = accented.filter((letter) => !(letter.baseAspect > 0)).map((letter) => `${letter.char} (needs ${letter.char.normalize("NFD")[0]})`);
    const signature = missing.join("");
    if (signature !== __privateGet(this, _unmeasuredWarned)) {
      __privateSet(this, _unmeasuredWarned, signature);
      console.warn(
        `[kit-personalisation] Can't size ${missing.join(", ")} against its base letter \u2014 that letter has no artwork on this sheet, so the configured accentScale (${configured}) is used instead.`
      );
    }
  }
  return (letter) => {
    if (letter.accent === "none") return { top: 0, fraction: 1 };
    const fraction = letter.baseAspect > 0 && letter.aspect > 0 ? letter.aspect / letter.baseAspect : 1 / configured;
    if (!(fraction > ACCENT_FRACTION_MIN && fraction < 1)) return { top: 0, fraction: 1 };
    return { top: letter.accent === "above" ? 1 - fraction : 0, fraction };
  };
};
_accentScaleSource = new WeakMap();
_unmeasuredWarned = new WeakMap();
_nameImageLetters = new WeakMap();
_nameImageNodes = new WeakMap();
_nameImagesKey = new WeakMap();
_namePreviewToken = new WeakMap();
letterArtwork_fn = async function(handle, text) {
  try {
    const product = await fetchProduct(handle);
    const letters = [];
    for (const char of text) {
      if (char === " ") {
        letters.push({ char, src: null, aspect: SPACE_ASPECT, height: 0, baseAspect: 0, accent: "none" });
        continue;
      }
      const src = findVariant(product.variants, char)?.featured_image?.src;
      if (!src) {
        console.warn(
          `[kit-personalisation] No variant image for '${char}' on "${handle}" \u2014 drawing the name as text instead.`
        );
        return null;
      }
      letters.push({ char, src, aspect: 1, height: 0, baseAspect: 0, accent: accentPlacement(char) });
    }
    const baseSrc = letters.map((letter) => {
      if (letter.accent === "none" || !letter.src) return null;
      const base = letter.char.normalize("NFD")[0];
      return findVariant(product.variants, base)?.featured_image?.src ?? null;
    });
    const [metrics, baseMetrics] = await Promise.all([
      Promise.all(letters.map((letter) => letter.src ? loadImageMetrics(letter.src) : { aspect: SPACE_ASPECT, height: 0 })),
      Promise.all(baseSrc.map((src) => src ? loadImageMetrics(src) : { aspect: 0, height: 0 }))
    ]);
    for (const [index, letter] of letters.entries()) {
      letter.aspect = metrics[index].aspect;
      letter.height = metrics[index].height;
      letter.baseAspect = baseMetrics[index].aspect;
    }
    return letters;
  } catch (err) {
    console.error(`[kit-personalisation] Failed to load letter artwork from "${handle}":`, err);
    return null;
  }
};
/**
 * Builds the <image> nodes for the current letters, reusing what's already
 * on screen when the artwork hasn't changed — otherwise every keystroke
 * would tear down and re-request the letters before the one just typed.
 */
renderNameImages_fn = function() {
  const group = __privateGet(this, _KitPersonalisation_instances, previewNameImages_get);
  if (!group) return;
  const letters = __privateGet(this, _nameImageLetters);
  const key = letters?.map((letter) => letter.src ?? "space").join("|") ?? "";
  if (key === __privateGet(this, _nameImagesKey)) return;
  __privateSet(this, _nameImagesKey, key);
  if (!letters?.length) {
    group.replaceChildren();
    __privateSet(this, _nameImageNodes, []);
    return;
  }
  const NS = "http://www.w3.org/2000/svg";
  __privateSet(this, _nameImageNodes, letters.map((letter) => {
    if (!letter.src) return null;
    const node = document.createElementNS(NS, "image");
    node.setAttribute("href", letter.src);
    node.setAttribute("preserveAspectRatio", "xMidYMid meet");
    node.setAttribute("class", "kit-personalisation__preview-letter");
    return node;
  }));
  group.replaceChildren(
    ...__privateGet(this, _nameImageNodes).filter((node) => node !== null)
  );
};
updateNamePreview_fn = async function(name) {
  const container = __privateGet(this, _KitPersonalisation_instances, previewContainer_get);
  if (!__privateGet(this, _KitPersonalisation_instances, previewNameImages_get) || !container) return;
  const token = ++__privateWrapper(this, _namePreviewToken)._;
  const { lettersHandle } = __privateMethod(this, _KitPersonalisation_instances, handlesForFont_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this));
  const characters = name.trim().normalize("NFC").toUpperCase();
  const letters = characters && lettersHandle ? await __privateMethod(this, _KitPersonalisation_instances, letterArtwork_fn).call(this, lettersHandle, characters) : null;
  if (token !== __privateGet(this, _namePreviewToken)) return;
  __privateSet(this, _nameImageLetters, letters);
  __privateMethod(this, _KitPersonalisation_instances, renderNameImages_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, layoutNameImages_fn).call(this);
  container.classList.toggle(NAME_ARTWORK_CLASS, Boolean(letters?.length));
};
/**
 * The name's currently rendered size, used as the starting point before a
 * fresh fit has run.
 *
 * @returns {number}
 */
currentNameSize_fn = function() {
  const pathEl = __privateGet(this, _KitPersonalisation_instances, previewNameTextPath_get);
  if (!pathEl) return __privateGet(this, _printLayout).name.maxSize;
  const size = Number.parseFloat(getComputedStyle(pathEl).fontSize);
  return Number.isFinite(size) && size > 0 ? size : __privateGet(this, _printLayout).name.maxSize;
};
applyPrintLayout_fn = function() {
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  const { number } = __privateGet(this, _printLayout);
  __privateMethod(this, _KitPersonalisation_instances, applyNameArc_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, currentNameSize_fn).call(this));
  __privateMethod(this, _KitPersonalisation_instances, applyNameImageArc_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, layoutNameImages_fn).call(this);
  const t = number.text;
  const textTop = ab.y + t.top / 100 * ab.height;
  const textHeight = t.height / 100 * ab.height;
  const textCentre = ab.x + ab.width / 2 + t.xOffset / 100 * ab.width;
  const size = __privateMethod(this, _KitPersonalisation_instances, numberSizeForHeight_fn).call(this, textHeight);
  const textBaseline = textTop + __privateMethod(this, _KitPersonalisation_instances, ascentRatio_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this)) * size;
  for (const el of [__privateGet(this, _KitPersonalisation_instances, previewNumber_get), __privateGet(this, _KitPersonalisation_instances, previewNumberStroke_get)]) {
    if (!el) continue;
    el.setAttribute("x", String(__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, textCentre)));
    el.setAttribute("y", String(__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, textBaseline)));
    el.style.setProperty("font-size", `${__privateMethod(this, _KitPersonalisation_instances, fixed_fn).call(this, size)}px`);
  }
  const i = number.image;
  const imageWidth = i.width / 100 * ab.width;
  __privateMethod(this, _KitPersonalisation_instances, positionDigitBand_fn).call(this, {
    x: ab.x + (ab.width - imageWidth) / 2 + i.xOffset / 100 * ab.width,
    y: ab.y + i.top / 100 * ab.height,
    width: imageWidth,
    height: i.height / 100 * ab.height
  });
};
/**
 * The digit images are HTML, positioned in the container's own pixel
 * space, while the artbox is in viewBox units — so they're mapped through
 * the SVG's screen matrix. That keeps them locked to the same artbox as
 * the SVG number under either preserveAspectRatio, instead of drifting
 * against it as the container's aspect ratio changes.
 *
 * @param {{ x: number, y: number, width: number, height: number }} box -
 *   The digit band in viewBox user units
 */
positionDigitBand_fn = function(box) {
  const imgs = __privateGet(this, _KitPersonalisation_instances, previewNumberImages_get);
  const svg = __privateGet(this, _KitPersonalisation_instances, previewSvg_get);
  const container = __privateGet(this, _KitPersonalisation_instances, previewContainer_get);
  if (!imgs || !svg || !container) return;
  if (__privateGet(this, _KitPersonalisation_instances, isShortsMode_get)) return;
  const { width: cw, height: ch } = container.getBoundingClientRect();
  if (!cw || !ch) return;
  const slice = (svg.getAttribute("preserveAspectRatio") ?? "").includes("slice");
  const scale = slice ? Math.max(cw / VIEWBOX_SIZE, ch / VIEWBOX_SIZE) : Math.min(cw / VIEWBOX_SIZE, ch / VIEWBOX_SIZE);
  const offsetX = (cw - VIEWBOX_SIZE * scale) / 2;
  const offsetY = (ch - VIEWBOX_SIZE * scale) / 2;
  imgs.style.left = `${offsetX + box.x * scale}px`;
  imgs.style.top = `${offsetY + box.y * scale}px`;
  imgs.style.width = `${box.width * scale}px`;
  imgs.style.height = `${box.height * scale}px`;
};
/**
 * Font size that renders the number at `targetHeight` user units, found by
 * measuring at a reference size. Falls back to a cap-height estimate when
 * the text isn't measurable (dialog closed, or no digits entered).
 *
 * @param {number} targetHeight
 * @returns {number}
 */
numberSizeForHeight_fn = function(targetHeight) {
  const el = __privateGet(this, _KitPersonalisation_instances, previewNumber_get);
  const font = __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this);
  const fallbackRatio = __privateGet(this, _numberEmRatio).get(font) ?? NUMBER_EM_HEIGHT_FALLBACK;
  if (!el || !el.textContent) return targetHeight / fallbackRatio;
  const previous = el.style.fontSize;
  el.style.fontSize = `${NUMBER_MEASURE_SIZE}px`;
  let measured = 0;
  try {
    measured = el.getBBox().height;
  } catch {
  }
  el.style.fontSize = previous;
  if (!measured) return targetHeight / fallbackRatio;
  __privateGet(this, _numberEmRatio).set(font, measured / NUMBER_MEASURE_SIZE);
  return NUMBER_MEASURE_SIZE * targetHeight / measured;
};
_numberEmRatio = new WeakMap();
/**
 * @param {number} n
 * @returns {number}
 */
fixed_fn = function(n) {
  return Math.round(n * 10) / 10;
};
/**
 * Size the name to span a fixed proportion of the arc, rather than
 * stepping through fixed sizes by character count.
 *
 * The old 26/20/16px buckets were tuned by eye and left short names badly
 * under-filled: the arc is ~309 user units long, and a 7-character name
 * at 26px covered barely a third of it, reading as a caption next to the
 * 126px number. Fitting also makes overflow structurally impossible, so
 * long names no longer need their own special case.
 *
 * Measured by temporarily setting a large reference size and reading the
 * text's advance width, which accounts for the actual font, its metrics
 * and the letter-spacing — a per-character estimate can't, since Palace
 * Main, Premier League and WSL have very different widths. Falls back to
 * an estimate when the text isn't measurable (the modal is closed, so the
 * dialog is display: none); #openModal re-runs this once it's on screen.
 *
 * @param {string} name
 * @returns {number} Font size in SVG user units.
 */
nameSizeForArc_fn = function(name) {
  if (!name) return __privateGet(this, _printLayout).name.maxSize;
  const pathEl = __privateGet(this, _KitPersonalisation_instances, previewNameTextPath_get);
  const arc = __privateGet(this, _KitPersonalisation_instances, previewNameArc_get);
  if (!pathEl || !arc) return __privateGet(this, _printLayout).name.maxSize;
  let arcLength = 0;
  try {
    arcLength = arc.getTotalLength();
  } catch {
  }
  if (!arcLength) return __privateGet(this, _printLayout).name.maxSize;
  const target = arcLength * __privateGet(this, _printLayout).name.fill;
  const previous = pathEl.style.getPropertyValue("--kit-preview-name-size");
  pathEl.style.setProperty("--kit-preview-name-size", `${NAME_MEASURE_SIZE}px`);
  let measured = 0;
  try {
    measured = /** @type {SVGTextContentElement} */
    pathEl.getComputedTextLength();
  } catch {
  }
  if (previous) pathEl.style.setProperty("--kit-preview-name-size", previous);
  else pathEl.style.removeProperty("--kit-preview-name-size");
  const size = measured > 0 ? NAME_MEASURE_SIZE * target / measured : target / (name.length * NAME_FALLBACK_ADVANCE);
  return Math.round(Math.min(__privateGet(this, _printLayout).name.maxSize, Math.max(NAME_SIZE_MIN, size)));
};
updatePreview_fn = function() {
  let name, number;
  if (__privateGet(this, _selectedType) === "player") {
    name = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerName_fn).call(this);
    number = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerNumber_fn).call(this);
  } else {
    name = __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value ?? "";
    number = __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value ?? "";
  }
  const nameEl = __privateGet(this, _KitPersonalisation_instances, previewNameTextPath_get);
  const nameStroke = __privateGet(this, _KitPersonalisation_instances, previewNameStroke_get);
  if (nameEl) {
    nameEl.textContent = name;
    const fitted = __privateMethod(this, _KitPersonalisation_instances, nameSizeForArc_fn).call(this, name);
    __privateMethod(this, _KitPersonalisation_instances, applyNameArc_fn).call(this, fitted);
    const size = `${fitted}px`;
    nameEl.style.setProperty("--kit-preview-name-size", size);
    if (nameStroke) {
      nameStroke.textContent = name;
      nameStroke.style.setProperty("--kit-preview-name-size", size);
    }
  }
  __privateMethod(this, _KitPersonalisation_instances, updateNamePreview_fn).call(this, name);
  __privateMethod(this, _KitPersonalisation_instances, updateGuides_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updateNumberPreview_fn).call(this, number).finally(() => {
    __privateMethod(this, _KitPersonalisation_instances, applyPrintLayout_fn).call(this);
    __privateMethod(this, _KitPersonalisation_instances, updateGuides_fn).call(this);
  });
};
updateNumberPreview_fn = async function(number) {
  const svgNumber = __privateGet(this, _KitPersonalisation_instances, previewNumber_get);
  const svgNumberStroke = __privateGet(this, _KitPersonalisation_instances, previewNumberStroke_get);
  const imgContainer = __privateGet(this, _KitPersonalisation_instances, previewNumberImages_get);
  if (!svgNumber || !imgContainer) return;
  if (!number) {
    svgNumber.textContent = "";
    if (svgNumberStroke) svgNumberStroke.textContent = "";
    imgContainer.innerHTML = "";
    imgContainer.hidden = true;
    svgNumber.style.display = "";
    if (svgNumberStroke) svgNumberStroke.style.display = "";
    return;
  }
  const font = __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this);
  const { numbersHandle } = __privateMethod(this, _KitPersonalisation_instances, handlesForFont_fn).call(this, font);
  if (!numbersHandle) {
    svgNumber.textContent = number;
    if (svgNumberStroke) svgNumberStroke.textContent = number;
    svgNumber.style.display = "";
    if (svgNumberStroke) svgNumberStroke.style.display = "";
    imgContainer.innerHTML = "";
    imgContainer.hidden = true;
    return;
  }
  try {
    const product = await fetchProduct(numbersHandle);
    const images = [];
    for (const digit of number) {
      const variant = findVariant(product.variants, digit);
      if (variant?.featured_image?.src) {
        images.push({ digit, src: variant.featured_image.src });
      } else {
        images.push(null);
      }
    }
    if (images.every((img) => img !== null)) {
      svgNumber.style.display = "none";
      if (svgNumberStroke) svgNumberStroke.style.display = "none";
      imgContainer.hidden = false;
      imgContainer.innerHTML = images.map((img) => `<img src="${img.src}" alt="${img.digit}" class="kit-personalisation__preview-digit">`).join("");
    } else {
      svgNumber.textContent = number;
      if (svgNumberStroke) svgNumberStroke.textContent = number;
      svgNumber.style.display = "";
      if (svgNumberStroke) svgNumberStroke.style.display = "";
      imgContainer.innerHTML = "";
      imgContainer.hidden = true;
    }
  } catch {
    svgNumber.textContent = number;
    if (svgNumberStroke) svgNumberStroke.textContent = number;
    svgNumber.style.display = "";
    if (svgNumberStroke) svgNumberStroke.style.display = "";
    imgContainer.innerHTML = "";
    imgContainer.hidden = true;
  }
};
// ── Preview guides (dev-only overlay) ───────────────────────────────────
//
// Turned on with ?kit-guides=1 (or #kit-guides) and built entirely from
// JS, so nothing is added to the shipped DOM otherwise. It exists to make
// the print area reviewable: the name, the SVG number and the digit-image
// number are positioned in three different coordinate systems, and the
// third one doesn't track the other two.
//
//  - name:          <textPath> on the arc, in the SVG's 400x400 viewBox
//  - number (text): <text x=200 y=170>, same viewBox
//  - number (imgs): an HTML div at top:35%/height:30% of the *container*
//
// The SVG scales with xMidYMid meet, so its viewBox is letterboxed inside
// the container — which means the % -based digit band drifts away from
// the name as the container's aspect ratio changes. The readout prints
// both, in their own units and in pixels, so the drift is measurable.
/** @returns {boolean} */
guidesEnabled_fn = function() {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.has("kit-guides") || url.hash === "#kit-guides";
  } catch {
    return false;
  }
};
_guidesGroup = new WeakMap();
_guidesBand = new WeakMap();
_guidesReadout = new WeakMap();
_guidesObserver = new WeakMap();
initPreviewGuides_fn = function() {
  const svg = __privateGet(this, _KitPersonalisation_instances, previewSvg_get);
  const container = __privateGet(this, _KitPersonalisation_instances, previewContainer_get);
  if (!svg || !container) return;
  const NS = "http://www.w3.org/2000/svg";
  const el = (name, attrs) => {
    const node = document.createElementNS(NS, name);
    for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, String(v));
    return node;
  };
  const g = el("g", { class: "kit-personalisation__guides" });
  for (let i = 50; i < 400; i += 50) {
    g.append(el("line", { class: "kit-personalisation__guide-grid", x1: i, y1: 0, x2: i, y2: 400 }));
    g.append(el("line", { class: "kit-personalisation__guide-grid", x1: 0, y1: i, x2: 400, y2: i }));
  }
  g.append(el("rect", { class: "kit-personalisation__guide-frame", x: 0, y: 0, width: 400, height: 400 }));
  g.append(el("line", { class: "kit-personalisation__guide-axis", x1: 200, y1: 0, x2: 200, y2: 400 }));
  g.append(el("line", { class: "kit-personalisation__guide-axis", x1: 0, y1: 200, x2: 400, y2: 200 }));
  const arc = __privateGet(this, _KitPersonalisation_instances, previewNameArc_get);
  const arcTrace = el("path", { class: "kit-personalisation__guide-arc", d: arc?.getAttribute("d") ?? "" });
  g.append(arcTrace);
  const nameBox = el("rect", { class: "kit-personalisation__guide-box kit-personalisation__guide-box--name" });
  g.append(nameBox);
  const numberAnchor = el("g", { class: "kit-personalisation__guide-anchor" });
  numberAnchor.append(el("line", { x1: 190, y1: 170, x2: 210, y2: 170 }));
  numberAnchor.append(el("line", { x1: 200, y1: 160, x2: 200, y2: 180 }));
  g.append(numberAnchor);
  const numberBox = el("rect", { class: "kit-personalisation__guide-box kit-personalisation__guide-box--number" });
  g.append(numberBox);
  const artbox = el("rect", { class: "kit-personalisation__guide-artbox" });
  g.append(artbox);
  const artboxLabel = el("text", { class: "kit-personalisation__guide-artbox-label", x: 0, y: 0 });
  g.append(artboxLabel);
  svg.append(g);
  __privateSet(this, _guidesGroup, g);
  g.__refs = { arcTrace, nameBox, numberAnchor, numberBox, artbox, artboxLabel };
  const band = document.createElement("div");
  band.className = "kit-personalisation__guide-band";
  band.dataset.kitGuideBand = "true";
  container.append(band);
  __privateSet(this, _guidesBand, band);
  const hud = document.createElement("div");
  hud.className = "kit-personalisation__guide-hud";
  const collapse = document.createElement("button");
  collapse.type = "button";
  collapse.className = "kit-personalisation__guide-collapse";
  collapse.textContent = "Guides \u25BE";
  collapse.addEventListener("click", () => {
    const collapsed = hud.classList.toggle("kit-personalisation__guide-hud--collapsed");
    collapse.textContent = collapsed ? "Guides \u25B8" : "Guides \u25BE";
  });
  hud.append(collapse);
  const body = document.createElement("div");
  body.className = "kit-personalisation__guide-hud-body";
  body.append(__privateMethod(this, _KitPersonalisation_instances, buildGuideControls_fn).call(this));
  const readout = document.createElement("pre");
  readout.className = "kit-personalisation__guide-readout";
  body.append(readout);
  __privateSet(this, _guidesReadout, readout);
  hud.append(body);
  __privateGet(this, _KitPersonalisation_instances, modal_get)?.append(hud);
  __privateSet(this, _guidesObserver, new ResizeObserver(() => __privateMethod(this, _KitPersonalisation_instances, updateGuides_fn).call(this)));
  __privateGet(this, _guidesObserver).observe(container);
  __privateMethod(this, _KitPersonalisation_instances, updateGuides_fn).call(this);
};
_guideSummary = new WeakMap();
/**
 * Reads/writes a dotted path on #printLayout, so each slider binds
 * straight to the value it edits.
 *
 * @param {string} path - e.g. "artbox.x", "name.fill"
 * @param {number} [value] - Omit to read
 * @returns {number}
 */
layoutValue_fn = function(path, value) {
  const keys = path.split(".");
  const last = keys.pop();
  let target = (
    /** @type {any} */
    __privateGet(this, _printLayout)
  );
  for (const key of keys) target = target[key];
  if (value !== void 0) target[last] = value;
  return target[last];
};
/**
 * Builds the tuning panel: a slider per value in PRINT_LAYOUT, plus a
 * summary of the result ready to paste back. Every control edits
 * #printLayout and re-applies it, so what's on screen is exactly what the
 * numbers describe.
 *
 * @returns {HTMLElement}
 */
buildGuideControls_fn = function() {
  const panel = document.createElement("div");
  panel.className = "kit-personalisation__guide-panel";
  const slider = (label, key, min, max, step, suffix = "") => {
    const row = document.createElement("label");
    row.className = "kit-personalisation__guide-row";
    const name = document.createElement("span");
    name.textContent = label;
    const input = document.createElement("input");
    input.type = "range";
    input.min = String(min);
    input.max = String(max);
    input.step = String(step);
    input.value = String(__privateMethod(this, _KitPersonalisation_instances, layoutValue_fn).call(this, key));
    const value = document.createElement("output");
    value.textContent = `${__privateMethod(this, _KitPersonalisation_instances, round_fn).call(this, __privateMethod(this, _KitPersonalisation_instances, layoutValue_fn).call(this, key), step)}${suffix}`;
    input.addEventListener("input", () => {
      __privateMethod(this, _KitPersonalisation_instances, layoutValue_fn).call(this, key, Number(input.value));
      value.textContent = `${__privateMethod(this, _KitPersonalisation_instances, round_fn).call(this, Number(input.value), step)}${suffix}`;
      __privateMethod(this, _KitPersonalisation_instances, applyGuideValues_fn).call(this);
    });
    row.append(name, input, value);
    return row;
  };
  const heading = (text) => {
    const h = document.createElement("p");
    h.className = "kit-personalisation__guide-heading";
    h.textContent = text;
    return h;
  };
  const toggle = (label, initial, onChange) => {
    const row = document.createElement("label");
    row.className = "kit-personalisation__guide-row kit-personalisation__guide-row--toggle";
    const input = document.createElement("input");
    input.type = "checkbox";
    input.checked = initial;
    input.addEventListener("change", () => onChange(input.checked));
    const name = document.createElement("span");
    name.textContent = label;
    row.append(input, name);
    return row;
  };
  panel.append(
    heading("Artbox \u2014 % of viewBox"),
    slider("x", "artbox.x", 0, 60, 0.5, "%"),
    slider("y", "artbox.y", 0, 80, 0.5, "%"),
    slider("width", "artbox.width", 10, 100, 0.5, "%"),
    slider("height", "artbox.height", 10, 100, 0.5, "%"),
    heading("Name \u2014 % of artbox"),
    slider("end inset", "name.inset", 0, 30, 0.5, "%"),
    slider("top edge", "name.top", 0, 100, 0.5, "%"),
    slider("curve depth", "name.curveDepth", 0, 40, 0.5, "%"),
    slider("fill of arc", "name.fill", 0.2, 1, 0.01),
    slider("max size", "name.maxSize", 16, 90, 1),
    heading("Name as image \u2014 % of artbox"),
    slider("top edge", "name.image.top", 0, 100, 0.5, "%"),
    slider("max height", "name.image.maxHeight", 2, 40, 0.5, "%"),
    slider("letter gap", "name.image.gap", 0, 40, 0.5, "%"),
    slider("accent scale", "name.image.accentScale", 1, 1.6, 0.01, "x"),
    slider("fill of arc", "name.image.fill", 0.2, 1, 0.01),
    heading("Number as text \u2014 % of artbox"),
    slider("top", "number.text.top", -20, 100, 0.5, "%"),
    slider("height", "number.text.height", 5, 100, 0.5, "%"),
    slider("x offset", "number.text.xOffset", -50, 50, 0.5, "%"),
    heading("Number as image \u2014 % of artbox"),
    slider("top", "number.image.top", -20, 100, 0.5, "%"),
    slider("height", "number.image.height", 5, 100, 0.5, "%"),
    slider("x offset", "number.image.xOffset", -50, 50, 0.5, "%"),
    slider("width", "number.image.width", 20, 140, 0.5, "%"),
    heading("Overlay mapping"),
    toggle("match the photo's crop (slice)", __privateGet(this, _KitPersonalisation_instances, previewSvg_get)?.getAttribute("preserveAspectRatio") === "xMidYMid slice", (checked) => {
      __privateGet(this, _KitPersonalisation_instances, previewSvg_get)?.setAttribute(
        "preserveAspectRatio",
        checked ? "xMidYMid slice" : "xMidYMid meet"
      );
      __privateMethod(this, _KitPersonalisation_instances, updateGuides_fn).call(this);
    })
  );
  const summary = document.createElement("pre");
  summary.className = "kit-personalisation__guide-summary";
  panel.append(summary);
  __privateSet(this, _guideSummary, summary);
  const copy = document.createElement("button");
  copy.type = "button";
  copy.className = "kit-personalisation__guide-copy";
  copy.textContent = "Copy values";
  copy.addEventListener("click", () => {
    navigator.clipboard?.writeText(summary.textContent ?? "");
    copy.textContent = "Copied";
    setTimeout(() => {
      copy.textContent = "Copy values";
    }, 1500);
  });
  panel.append(copy);
  const reset = document.createElement("button");
  reset.type = "button";
  reset.className = "kit-personalisation__guide-copy";
  reset.textContent = "Reload to reset";
  reset.addEventListener("click", () => window.location.reload());
  panel.append(reset);
  return panel;
};
/**
 * The arc's `d`. Read straight off the attribute — #applyNameArc owns it,
 * and the CSS `d` property it used to be read from isn't implemented in
 * every engine.
 *
 * @returns {string | null}
 */
currentArcD_fn = function() {
  return __privateGet(this, _KitPersonalisation_instances, previewNameArc_get)?.getAttribute("d") ?? null;
};
/**
 * How far a box escapes the artbox on each side, in user units — 0 on a
 * side means it's inside. Lets the panel say whether the current name or
 * number would print outside the printable area.
 *
 * @param {DOMRect | null} box
 * @returns {string}
 */
artboxOverflow_fn = function(box) {
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  if (!box || !ab) return "-";
  const left = Math.max(0, ab.x - box.x);
  const right = Math.max(0, box.x + box.width - (ab.x + ab.width));
  const top = Math.max(0, ab.y - box.y);
  const bottom = Math.max(0, box.y + box.height - (ab.y + ab.height));
  if (!left && !right && !top && !bottom) return "inside";
  const r = (n) => Math.round(n);
  return `OUT by L${r(left)} R${r(right)} T${r(top)} B${r(bottom)}`;
};
/**
 * @param {number} n
 * @param {number} step
 * @returns {number}
 */
round_fn = function(n, step) {
  return step < 1 ? Math.round(n * 100) / 100 : Math.round(n);
};
/** Pushes the panel's current values onto the preview. */
applyGuideValues_fn = function() {
  __privateMethod(this, _KitPersonalisation_instances, applyPrintLayout_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
};
/**
 * The digit band's applied box, and whether it's the renderer currently on
 * screen — the two number renderers swap depending on whether the selected
 * font has artwork for every digit entered.
 *
 * @returns {string}
 */
digitBandDescription_fn = function() {
  const imgs = __privateGet(this, _KitPersonalisation_instances, previewNumberImages_get);
  if (!imgs) return "-";
  const { left, top, width, height } = imgs.style;
  if (!left) return "(not positioned yet)";
  const state = imgs.hidden ? "not in use" : "IN USE";
  return `${Math.round(Number.parseFloat(left))},${Math.round(Number.parseFloat(top))} ${Math.round(Number.parseFloat(width))}x${Math.round(Number.parseFloat(height))}px (${state})`;
};
/**
 * The letter artwork's state: how many letters it holds and whether it's
 * the renderer currently on screen — the name swaps between artwork and
 * live text depending on whether the selected font has artwork for every
 * character entered.
 *
 * @returns {string}
 */
letterArtworkDescription_fn = function() {
  const letters = __privateGet(this, _nameImageLetters);
  if (!letters?.length) return "not in use (name drawn as text)";
  const accents = letters.filter((letter) => letter.accent !== "none");
  const canvases = [...new Set(letters.filter((l) => l.height).map((l) => l.height))];
  const detail = accents.map((l) => `${l.char} ${l.baseAspect > 0 ? (l.aspect / l.baseAspect).toFixed(3) : "?"}`).join(" ");
  const accentNote = accents.length ? `accents ${__privateGet(this, _accentScaleSource)}: ${detail}` : "no accents";
  return `${letters.length} letters IN USE  (${accentNote}; canvas ${canvases.join("/") || "?"}px)`;
};
/** The panel's values, formatted for pasting back as a change request. */
updateGuideSummary_fn = function() {
  const summary = __privateGet(this, _guideSummary);
  if (!summary) return;
  const l = __privateGet(this, _printLayout);
  const nameSize = __privateGet(this, _KitPersonalisation_instances, previewNameTextPath_get) ? getComputedStyle(__privateGet(this, _KitPersonalisation_instances, previewNameTextPath_get)).fontSize : "-";
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  const p = (n) => __privateMethod(this, _KitPersonalisation_instances, round_fn).call(this, n, 0.5);
  summary.textContent = [
    `viewport ${window.innerWidth}px  |  mapping ${__privateGet(this, _KitPersonalisation_instances, previewSvg_get)?.getAttribute("preserveAspectRatio") || "xMidYMid meet"}`,
    ``,
    `const PRINT_LAYOUT = {`,
    `  artbox: { x: ${p(l.artbox.x)}, y: ${p(l.artbox.y)}, width: ${p(l.artbox.width)}, height: ${p(l.artbox.height)} },`,
    `  name: {`,
    `    inset: ${p(l.name.inset)},`,
    `    top: ${p(l.name.top)},`,
    `    curveDepth: ${p(l.name.curveDepth)},`,
    `    fill: ${__privateMethod(this, _KitPersonalisation_instances, round_fn).call(this, l.name.fill, 0.01)},`,
    `    maxSize: ${Math.round(l.name.maxSize)},`,
    `    image: { top: ${p(l.name.image.top)}, maxHeight: ${p(l.name.image.maxHeight)}, gap: ${p(l.name.image.gap)}, fill: ${__privateMethod(this, _KitPersonalisation_instances, round_fn).call(this, l.name.image.fill, 0.01)}, accentScale: ${__privateMethod(this, _KitPersonalisation_instances, round_fn).call(this, l.name.image.accentScale, 0.01)} },`,
    `  },`,
    `  number: {`,
    `    text: { top: ${p(l.number.text.top)}, height: ${p(l.number.text.height)}, xOffset: ${p(l.number.text.xOffset)} },`,
    `    image: { top: ${p(l.number.image.top)}, height: ${p(l.number.image.height)}, xOffset: ${p(l.number.image.xOffset)}, width: ${p(l.number.image.width)} },`,
    `  },`,
    `};`,
    ``,
    `resolved for this preview (viewBox units)`,
    `  artbox      x ${Math.round(ab.x)} y ${Math.round(ab.y)} w ${Math.round(ab.width)} h ${Math.round(ab.height)}`,
    `  name arc    ${__privateMethod(this, _KitPersonalisation_instances, currentArcD_fn).call(this) ?? "-"}`,
    `  name size   ${nameSize}`,
    `  number text y ${__privateGet(this, _KitPersonalisation_instances, previewNumber_get)?.getAttribute("y") ?? "-"}  size ${__privateGet(this, _KitPersonalisation_instances, previewNumber_get) ? getComputedStyle(__privateGet(this, _KitPersonalisation_instances, previewNumber_get)).fontSize : "-"}`,
    `  name imgs   ${__privateMethod(this, _KitPersonalisation_instances, letterArtworkDescription_fn).call(this)}`,
    `  number imgs ${__privateMethod(this, _KitPersonalisation_instances, digitBandDescription_fn).call(this)}`
  ].join("\n");
};
/**
 * Refreshes the guide boxes and the readout. Safe to call at any time —
 * a no-op when the overlay isn't enabled.
 */
updateGuides_fn = function() {
  const g = __privateGet(this, _guidesGroup);
  if (!g) return;
  const refs = (
    /** @type {any} */
    g.__refs
  );
  const svg = __privateGet(this, _KitPersonalisation_instances, previewSvg_get);
  const container = __privateGet(this, _KitPersonalisation_instances, previewContainer_get);
  if (!refs || !svg || !container) return;
  const bbox = (node) => {
    if (!node) return null;
    try {
      const b = (
        /** @type {SVGGraphicsElement} */
        node.getBBox()
      );
      return b.width > 0 && b.height > 0 ? b : null;
    } catch {
      return null;
    }
  };
  const applyBox = (rect, b) => {
    if (!b) {
      rect.setAttribute("width", "0");
      rect.setAttribute("height", "0");
      return;
    }
    rect.setAttribute("x", String(b.x));
    rect.setAttribute("y", String(b.y));
    rect.setAttribute("width", String(b.width));
    rect.setAttribute("height", String(b.height));
  };
  const ab = __privateMethod(this, _KitPersonalisation_instances, artboxUnits_fn).call(this);
  if (ab && refs.artbox) {
    refs.artbox.setAttribute("x", String(ab.x));
    refs.artbox.setAttribute("y", String(ab.y));
    refs.artbox.setAttribute("width", String(ab.width));
    refs.artbox.setAttribute("height", String(ab.height));
    refs.artboxLabel.setAttribute("x", String(ab.x + 2));
    refs.artboxLabel.setAttribute("y", String(Math.max(10, ab.y - 4)));
    refs.artboxLabel.textContent = `artbox ${Math.round(ab.width)} x ${Math.round(ab.height)}`;
  }
  const arcD = __privateMethod(this, _KitPersonalisation_instances, currentArcD_fn).call(this);
  if (arcD) refs.arcTrace.setAttribute("d", arcD);
  const nameEl = this.querySelector(".kit-personalisation__preview-name");
  const numberEl = __privateGet(this, _KitPersonalisation_instances, previewNumber_get);
  const nameBBox = bbox(nameEl);
  const numberBBox = bbox(numberEl);
  applyBox(refs.nameBox, nameBBox);
  applyBox(refs.numberBox, numberBBox);
  const cRect = container.getBoundingClientRect();
  const scale = Math.min(cRect.width / 400, cRect.height / 400);
  const viewW = 400 * scale;
  const viewH = 400 * scale;
  const viewLeft = (cRect.width - viewW) / 2;
  const viewTop = (cRect.height - viewH) / 2;
  const imgs = __privateGet(this, _KitPersonalisation_instances, previewNumberImages_get);
  const band = __privateGet(this, _guidesBand);
  let bandRect = null;
  if (imgs && band) {
    const s = getComputedStyle(imgs);
    band.style.top = s.top;
    band.style.height = s.height;
    band.style.left = s.left;
    band.style.width = s.width;
    const iRect = imgs.getBoundingClientRect();
    bandRect = {
      topPx: Math.round(iRect.top - cRect.top),
      heightPx: Math.round(iRect.height),
      topCss: s.top,
      heightCss: s.height
    };
  }
  const numberStyle = numberEl ? getComputedStyle(numberEl) : null;
  const nameTextPath = __privateGet(this, _KitPersonalisation_instances, previewNameTextPath_get);
  const namePathStyle = nameTextPath ? getComputedStyle(nameTextPath) : null;
  const r = (n) => Math.round(n * 10) / 10;
  const lines = [
    `container      ${r(cRect.width)} x ${r(cRect.height)} px`,
    `viewBox 400^2  scale ${r(scale)}  ->  ${r(viewW)} x ${r(viewH)} px`,
    `               offset left ${r(viewLeft)}  top ${r(viewTop)} px`,
    `1 svg unit     = ${r(scale)} px`,
    ``,
    `NAME  (svg units, on arc)`,
    `  arc d        ${refs.arcTrace.getAttribute("d")}`,
    `  font-size    ${namePathStyle?.fontSize ?? "-"}`,
    `  text         "${nameTextPath?.textContent ?? ""}"`,
    nameBBox ? `  bbox         x ${r(nameBBox.x)} y ${r(nameBBox.y)} w ${r(nameBBox.width)} h ${r(nameBBox.height)}` : `  bbox         (not rendered)`,
    `  vs artbox    ${__privateMethod(this, _KitPersonalisation_instances, artboxOverflow_fn).call(this, nameBBox)}`,
    ``,
    `NUMBER as <text> (svg units)`,
    `  x / y        ${numberEl?.getAttribute("x") ?? "-"} / ${numberEl?.getAttribute("y") ?? "-"} (attributes)`,
    `  y offset     ${(numberStyle?.getPropertyValue("--kit-preview-number-offset") || "0").trim()} (css transform)`,
    `  font-size    ${numberStyle?.fontSize ?? "-"}`,
    `  baseline     ${numberEl?.getAttribute("dominant-baseline") ?? "-"}`,
    numberBBox ? `  bbox         x ${r(numberBBox.x)} y ${r(numberBBox.y)} w ${r(numberBBox.width)} h ${r(numberBBox.height)}` : `  bbox         (not rendered - digit images in use)`,
    `  vs artbox    ${__privateMethod(this, _KitPersonalisation_instances, artboxOverflow_fn).call(this, numberBBox)}`,
    ``,
    `NUMBER as images (% of container, NOT the viewBox)`,
    bandRect ? `  css          top ${bandRect.topCss}  height ${bandRect.heightCss}` : `  css          -`,
    bandRect ? `  actual       top ${bandRect.topPx}px  height ${bandRect.heightPx}px` : `  actual       -`,
    bandRect ? `  in svg units top ${r((bandRect.topPx - viewTop) / scale)}  height ${r(bandRect.heightPx / scale)}` : `  in svg units -`,
    `  visible      ${imgs && !imgs.hidden ? "yes" : "no"}`
  ];
  if (__privateGet(this, _guidesReadout)) __privateGet(this, _guidesReadout).textContent = lines.join("\n");
  __privateMethod(this, _KitPersonalisation_instances, updateGuideSummary_fn).call(this);
};
updatePreviewFont_fn = function() {
  const container = __privateGet(this, _KitPersonalisation_instances, previewContainer_get);
  if (!container) return;
  const font = __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this);
  for (const cls2 of Object.values(FONT_CLASS_MAP)) {
    container.classList.remove(cls2);
  }
  const cls = FONT_CLASS_MAP[font];
  if (cls) container.classList.add(cls);
  const { colour, strokeColour } = __privateMethod(this, _KitPersonalisation_instances, coloursForFont_fn).call(this, font);
  container.style.setProperty("--preview-colour", colour ?? "#ffffff");
  container.style.setProperty("--preview-stroke-colour", strokeColour ?? "#0a0a0a");
};
coloursForFont_fn = function(font) {
  const { lettersHandle, numbersHandle } = __privateMethod(this, _KitPersonalisation_instances, handlesForFont_fn).call(this, font);
  const handle = lettersHandle || numbersHandle;
  if (!handle) return { colour: null, strokeColour: null };
  const parts = handle.split("-");
  const colourName = parts[2];
  return {
    colour: COLOUR_MAP[colourName] ?? null,
    strokeColour: STROKE_COLOUR_MAP[colourName] ?? "#ffffff"
  };
};
nameMaxLength_fn = function() {
  return Number(this.dataset.nameMax) || 13;
};
updateNameCount_fn = function() {
  const countEl = __privateGet(this, _KitPersonalisation_instances, nameCountEl_get);
  const input = __privateGet(this, _KitPersonalisation_instances, nameInput_get);
  if (!countEl || !input) return;
  countEl.textContent = `${input.value.length}/${__privateMethod(this, _KitPersonalisation_instances, nameMaxLength_fn).call(this)}`;
};
/**
 * The name and number, e.g. "SMITH #10".
 *
 * @returns {string}
 */
nameNumberText_fn = function() {
  let name, number;
  if (__privateGet(this, _selectedType) === "player") {
    name = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerName_fn).call(this);
    number = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerNumber_fn).call(this);
  } else {
    name = __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value.trim().toUpperCase() ?? "";
    number = __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value.trim() ?? "";
  }
  const parts = [];
  if (name) parts.push(name);
  if (number) parts.push(`#${number}`);
  return parts.join(" ");
};
/**
 * The remaining options (font + sleeve badges) shown as the trigger summary.
 *
 * @returns {string}
 */
otherOptionsText_fn = function() {
  const parts = [];
  if (__privateMethod(this, _KitPersonalisation_instances, hasNameOrNumber_fn).call(this) && __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this)) {
    parts.push(__privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this));
  }
  const badges = __privateMethod(this, _KitPersonalisation_instances, getSelectedBadges_fn).call(this);
  if (badges.length) parts.push(badges.map((b) => b.title).join(" + "));
  const specials = __privateMethod(this, _KitPersonalisation_instances, getSelectedSpecials_fn).call(this);
  if (specials.length) parts.push(specials.map((s) => s.title).join(" + "));
  return parts.join(" \xB7 ");
};
/**
 * Once personalised, show the name/number as the trigger title, the remaining
 * options as the summary, and change the CTA label (e.g. "Get started" → "Update").
 */
updateTriggerState_fn = function() {
  const has = __privateMethod(this, _KitPersonalisation_instances, hasPersonalisation_fn).call(this);
  const titleEl = __privateGet(this, _KitPersonalisation_instances, titleEl_get);
  const summaryEl = __privateGet(this, _KitPersonalisation_instances, summaryEl_get);
  const subtitleEl = __privateGet(this, _KitPersonalisation_instances, subtitleEl_get);
  const ctaEl = __privateGet(this, _KitPersonalisation_instances, ctaLabelEl_get);
  if (has) {
    const nameNumber = __privateMethod(this, _KitPersonalisation_instances, nameNumberText_fn).call(this);
    if (titleEl) {
      titleEl.textContent = nameNumber || titleEl.dataset.titleDefault || titleEl.textContent;
    }
    if (summaryEl) {
      summaryEl.textContent = __privateMethod(this, _KitPersonalisation_instances, otherOptionsText_fn).call(this);
      summaryEl.hidden = summaryEl.textContent.length === 0;
    }
    if (subtitleEl) subtitleEl.hidden = true;
    if (ctaEl) ctaEl.textContent = ctaEl.dataset.ctaActive || ctaEl.textContent;
    this.classList.add("kit-personalisation--personalised");
  } else {
    if (titleEl) titleEl.textContent = titleEl.dataset.titleDefault || titleEl.textContent;
    if (summaryEl) {
      summaryEl.textContent = "";
      summaryEl.hidden = true;
    }
    if (subtitleEl) subtitleEl.hidden = false;
    if (ctaEl) ctaEl.textContent = ctaEl.dataset.ctaDefault || ctaEl.textContent;
    this.classList.remove("kit-personalisation--personalised");
  }
};
/**
 * @param {string} message
 */
showError_fn = function(message) {
  for (const el of __privateGet(this, _KitPersonalisation_instances, errorEls_get)) {
    el.textContent = message;
    el.hidden = false;
  }
};
clearError_fn = function() {
  for (const el of __privateGet(this, _KitPersonalisation_instances, errorEls_get)) {
    el.textContent = "";
    el.hidden = true;
  }
};
// ── Cart integration ────────────────────────────────────────────────────
/**
 * Find the product form and intercept its submission.
 *
 * @param {AbortSignal} signal
 */
interceptForm_fn = function(signal) {
  const section = this.closest("[data-section-id]") || this.closest(".shopify-section");
  if (!section) return;
  const form = section.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  __privateSet(this, _form, form);
  __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
  window.addEventListener("submit", __privateGet(this, _onFormSubmit), { capture: true, signal });
};
_form = new WeakMap();
_currentGroupKey = new WeakMap();
_onFormSubmit = new WeakMap();
syncFormProperties_fn = function() {
  const form = __privateGet(this, _form);
  if (!form) return;
  form.querySelectorAll("[data-kit-property]").forEach((el) => el.remove());
  if (!__privateMethod(this, _KitPersonalisation_instances, hasPersonalisation_fn).call(this)) {
    __privateSet(this, _currentGroupKey, `kit-${Date.now()}`);
    return;
  }
  let name, number;
  if (__privateGet(this, _selectedType) === "player") {
    name = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerName_fn).call(this);
    number = __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerNumber_fn).call(this);
  } else {
    name = __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value.trim().toUpperCase() ?? "";
    number = __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value.trim() ?? "";
  }
  const font = __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this);
  const addHidden = (key, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${key}]`;
    input.value = value;
    input.dataset.kitProperty = "true";
    form.appendChild(input);
  };
  addHidden("_personalisation_group", __privateGet(this, _currentGroupKey));
  if (__privateMethod(this, _KitPersonalisation_instances, hasNameOrNumber_fn).call(this)) {
    if (name) addHidden("Name", name);
    if (number) addHidden("Number", number);
    if (font) addHidden("Font", font);
    const { lettersHandle, numbersHandle } = __privateMethod(this, _KitPersonalisation_instances, handlesForFont_fn).call(this, font);
    if (lettersHandle) addHidden("_letters_handle", lettersHandle);
    if (numbersHandle) addHidden("_numbers_handle", numbersHandle);
  }
};
checkStock_fn = async function(name, number, font) {
  if (!font) return [];
  const { lettersHandle, numbersHandle } = __privateMethod(this, _KitPersonalisation_instances, handlesForFont_fn).call(this, font);
  const [letters, numbers] = await Promise.all([
    __privateMethod(this, _KitPersonalisation_instances, checkCharacterStock_fn).call(this, name, lettersHandle, "Letter"),
    __privateMethod(this, _KitPersonalisation_instances, checkCharacterStock_fn).call(this, number, numbersHandle, "Number")
  ]);
  return [...letters, ...numbers];
};
checkCharacterStock_fn = async function(characters, handle, label) {
  const unavailable = [];
  if (!characters || !handle) return unavailable;
  try {
    productCache.delete(handle);
    const product = await fetchProduct(handle);
    const needed = /* @__PURE__ */ new Map();
    for (const char of characters) {
      if (char === " ") continue;
      needed.set(char, (needed.get(char) ?? 0) + 1);
    }
    for (const [char, qty] of needed) {
      const variant = findVariant(product.variants, char);
      if (!variant || !variant.available) {
        unavailable.push(`${label} '${char}'`);
      } else if (variant.inventory_management && variant.inventory_policy === "deny" && variant.inventory_quantity < qty) {
        unavailable.push(`${label} '${char}' (only ${variant.inventory_quantity} in stock, need ${qty})`);
      }
    }
  } catch (err) {
    console.error(`[kit-personalisation] Failed to check ${label.toLowerCase()} stock:`, err);
  }
  return unavailable;
};
_stockCheckPromise = new WeakMap();
_stockCheckKey = new WeakMap();
/**
 * The name/number and the font they'll be printed in.
 *
 * @returns {{ name: string, number: string, font: string }}
 */
currentPersonalisation_fn = function() {
  if (__privateGet(this, _selectedType) === "player") {
    return {
      name: __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerName_fn).call(this).normalize("NFC").toUpperCase(),
      number: __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerNumber_fn).call(this),
      font: __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this)
    };
  }
  return {
    name: __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value.trim().normalize("NFC").toUpperCase() ?? "",
    number: __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value.trim() ?? "",
    font: __privateMethod(this, _KitPersonalisation_instances, getSelectedFont_fn).call(this)
  };
};
/**
 * Starts the character availability check as soon as the order summary
 * opens, so it's already resolved (or nearly) by the time the customer
 * hits "Confirm & add to basket" — rather than being two blocking product
 * fetches standing between that click and the cart.
 */
prewarmStockCheck_fn = function() {
  const { name, number, font } = __privateMethod(this, _KitPersonalisation_instances, currentPersonalisation_fn).call(this);
  if (!font || !name && !number) {
    __privateSet(this, _stockCheckPromise, null);
    __privateSet(this, _stockCheckKey, "");
    return;
  }
  const key = `${font}|${name}|${number}`;
  if (__privateGet(this, _stockCheckKey) === key && __privateGet(this, _stockCheckPromise)) return;
  __privateSet(this, _stockCheckKey, key);
  __privateSet(this, _stockCheckPromise, __privateMethod(this, _KitPersonalisation_instances, checkStock_fn).call(this, name, number, font));
};
addPersonalisedToCart_fn = async function(form) {
  const { name, number, font } = __privateMethod(this, _KitPersonalisation_instances, currentPersonalisation_fn).call(this);
  const hasNameOrNumber = name.length > 0 || number.length > 0;
  const badges = __privateMethod(this, _KitPersonalisation_instances, getSelectedBadges_fn).call(this);
  const specials = __privateMethod(this, _KitPersonalisation_instances, getSelectedSpecials_fn).call(this);
  const groupKey = __privateGet(this, _currentGroupKey);
  const addToCart = form.closest("product-form-component")?.querySelector("add-to-cart-component");
  addToCart?.disable?.();
  try {
    if (hasNameOrNumber) {
      const key = `${font}|${name}|${number}`;
      const pending = __privateGet(this, _stockCheckKey) === key && __privateGet(this, _stockCheckPromise) ? __privateGet(this, _stockCheckPromise) : __privateMethod(this, _KitPersonalisation_instances, checkStock_fn).call(this, name, number, font);
      const unavailable = await pending;
      if (unavailable.length > 0) {
        __privateMethod(this, _KitPersonalisation_instances, showError_fn).call(this, `The following characters are currently unavailable in ${font}: ${unavailable.join(", ")}`);
        return false;
      }
    }
    const shirtItem = __privateMethod(this, _KitPersonalisation_instances, buildShirtItem_fn).call(this, form);
    if (!shirtItem) return false;
    if (!shirtItem.properties) shirtItem.properties = {};
    shirtItem.properties._personalisation_group = groupKey;
    if (hasNameOrNumber) {
      if (name) shirtItem.properties.Name = name;
      if (number) shirtItem.properties.Number = number;
      if (font) shirtItem.properties.Font = font;
      const { lettersHandle, numbersHandle } = __privateMethod(this, _KitPersonalisation_instances, handlesForFont_fn).call(this, font);
      if (lettersHandle) shirtItem.properties._letters_handle = lettersHandle;
      if (numbersHandle) shirtItem.properties._numbers_handle = numbersHandle;
    }
    const items = [shirtItem];
    if (hasNameOrNumber && __privateGet(this, _feeProduct)) {
      const feeVariant = findFeeVariant(__privateGet(this, _feeProduct).variants);
      if (feeVariant) {
        items.push({
          id: feeVariant.id,
          quantity: 1,
          properties: { _personalisation_for: groupKey }
        });
      }
    }
    for (const badge of badges) {
      if (!badge.id) continue;
      items.push({
        id: badge.id,
        quantity: 1,
        properties: { _personalisation_for: groupKey, _sleeve_badge: badge.title }
      });
    }
    for (const special of specials) {
      if (!special.id) continue;
      items.push({
        id: special.id,
        quantity: 1,
        properties: { _personalisation_for: groupKey, _special_edition: special.title }
      });
    }
    const sectionIds = __privateMethod(this, _KitPersonalisation_instances, cartSectionIds_fn).call(this);
    const payload = { items };
    if (sectionIds.length > 0) payload.sections = sectionIds.join(",");
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
    const result = await res.json().catch(() => null);
    if (!res.ok) {
      const message = result?.description || result?.message || "";
      __privateMethod(this, _KitPersonalisation_instances, showError_fn).call(this, message || "Sorry, this item could not be added to your cart.");
      return false;
    }
    const cart = await (await fetch("/cart.js")).json();
    const visibleCount = cart.items.reduce(
      (sum, item) => item.properties?._personalisation_for ? sum : sum + item.quantity,
      0
    );
    const sections = result?.sections ?? {};
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: { ...cart, item_count: visibleCount },
          sourceId: form.closest("product-form-component")?.id || "kit-personalisation",
          // `source: 'product-form-component'` makes the cart icon increment the
          // bubble by `itemCount` (the visible shirt quantity), matching a normal add.
          data: {
            source: "product-form-component",
            itemCount: shirtItem.quantity,
            sections
          }
        }
      })
    );
    __privateMethod(this, _KitPersonalisation_instances, reset_fn).call(this);
    return true;
  } catch (err) {
    console.error("[kit-personalisation] Failed to add personalised item:", err);
    __privateMethod(this, _KitPersonalisation_instances, showError_fn).call(this, "Sorry, something went wrong adding your item.");
    return false;
  } finally {
    addToCart?.enable?.();
  }
};
/**
 * Build the shirt line item from the product form (variant id, quantity,
 * line-item properties — which already include Name/Number/Font/group key).
 *
 * @param {HTMLFormElement} form
 * @returns {{ id: string|number, quantity: number, properties?: object, selling_plan?: string|number } | null}
 */
buildShirtItem_fn = function(form) {
  const formData = new FormData(form);
  const id = formData.get("id");
  if (!id) return null;
  const quantity = Number(formData.get("quantity")) || 1;
  const properties = {};
  for (const [key, value] of formData.entries()) {
    const match = key.match(/^properties\[(.+)\]$/);
    if (match) properties[match[1]] = value;
  }
  const item = { id, quantity };
  if (Object.keys(properties).length > 0) item.properties = properties;
  const sellingPlan = formData.get("selling_plan");
  if (sellingPlan) item.selling_plan = sellingPlan;
  return item;
};
/**
 * The section ids the theme's cart component morphs after an add — passed
 * to /cart/add.js so the markup comes back with the add response.
 *
 * @returns {string[]}
 */
cartSectionIds_fn = function() {
  return [
    ...new Set(
      [...document.querySelectorAll("cart-items-component")].map((el) => el.dataset.sectionId).filter(Boolean)
    )
  ];
};
/**
 * Clear the custom-name inputs (name, number, font, sleeve badges).
 */
clearCustomInputs_fn = function() {
  if (__privateGet(this, _KitPersonalisation_instances, nameInput_get)) __privateGet(this, _KitPersonalisation_instances, nameInput_get).value = "";
  if (__privateGet(this, _KitPersonalisation_instances, numberInput_get)) __privateGet(this, _KitPersonalisation_instances, numberInput_get).value = "";
  __privateMethod(this, _KitPersonalisation_instances, updateNameCount_fn).call(this);
  const radios = [...__privateGet(this, _KitPersonalisation_instances, fontRadios_get)];
  radios.forEach((radio, i) => {
    radio.checked = i === 0;
  });
  for (const btn of __privateGet(this, _KitPersonalisation_instances, badgeButtons_get)) {
    btn.setAttribute("aria-pressed", "false");
    btn.removeAttribute("aria-disabled");
    btn.classList.remove("kit-personalisation__badge-option--locked");
  }
  __privateMethod(this, _KitPersonalisation_instances, updateBadgeAvailability_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
};
clearPlayerSelection_fn = function() {
  __privateSet(this, _selectedPlayer, null);
  for (const card of __privateGet(this, _KitPersonalisation_instances, playerCards_get)) {
    card.classList.remove("kit-personalisation__player-card--active");
    card.setAttribute("aria-pressed", "false");
  }
  __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
};
clearPlayerInput_fn = function() {
  __privateMethod(this, _KitPersonalisation_instances, clearPlayerSelection_fn).call(this);
  __privateSet(this, _selectedCategory, null);
  for (const btn of __privateGet(this, _KitPersonalisation_instances, categoryButtons_get)) {
    btn.classList.remove("kit-personalisation__category-btn--active");
  }
  const dropdown = __privateGet(this, _KitPersonalisation_instances, playerDropdown_get);
  if (dropdown) dropdown.hidden = true;
};
/**
 * Clear the special-edition selections.
 */
clearSpecialInputs_fn = function() {
  for (const btn of __privateGet(this, _KitPersonalisation_instances, specialButtons_get)) {
    btn.setAttribute("aria-pressed", "false");
  }
  __privateMethod(this, _KitPersonalisation_instances, updateSpecialState_fn).call(this);
};
/**
 * Reset every personalisation field back to its initial state after the
 * shirt has been added to the cart.
 */
reset_fn = function() {
  __privateMethod(this, _KitPersonalisation_instances, clearCustomInputs_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, clearPlayerInput_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, clearSpecialInputs_fn).call(this);
  __privateSet(this, _selectedType, null);
  __privateMethod(this, _KitPersonalisation_instances, updateStepTitle_fn).call(this, null);
  __privateSet(this, _stockCheckPromise, null);
  __privateSet(this, _stockCheckKey, "");
  __privateMethod(this, _KitPersonalisation_instances, clearError_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updateTriggerState_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, syncFormProperties_fn).call(this);
  __privateSet(this, _confirmedSnapshot, __privateMethod(this, _KitPersonalisation_instances, captureSnapshot_fn).call(this));
};
/**
 * Captures references to whatever is currently selected — squad/tab/card
 * buttons, the checked font radio, pressed badge/special buttons — plus
 * the raw name/number text. Restoring later replays clicks on these same
 * elements rather than re-deriving state, so it reuses the exact click
 * handlers that built it in the first place.
 *
 * @returns {object}
 */
captureSnapshot_fn = function() {
  return {
    type: __privateGet(this, _selectedType),
    categoryBtn: [...__privateGet(this, _KitPersonalisation_instances, categoryButtons_get)].find(
      (b) => b.classList.contains("kit-personalisation__category-btn--active")
    ) ?? null,
    playerTab: [...__privateGet(this, _KitPersonalisation_instances, playerTabs_get)].find((t) => t.getAttribute("aria-selected") === "true") ?? null,
    playerCard: [...__privateGet(this, _KitPersonalisation_instances, playerCards_get)].find(
      (c) => c.classList.contains("kit-personalisation__player-card--active")
    ) ?? null,
    name: __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value ?? "",
    number: __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value ?? "",
    fontRadio: [...__privateGet(this, _KitPersonalisation_instances, fontRadios_get)].find((r) => r.checked) ?? null,
    badgeButtons: [...__privateGet(this, _KitPersonalisation_instances, badgeButtons_get)].filter((b) => b.getAttribute("aria-pressed") === "true"),
    specialButtons: [...__privateGet(this, _KitPersonalisation_instances, specialButtons_get)].filter(
      (b) => b.getAttribute("aria-pressed") === "true"
    )
  };
};
/**
 * Rolls every field back to a previously captured snapshot — used when
 * the modal is dismissed without hitting Done, so in-progress edits never
 * reach the cart. Clears everything first, then replays clicks on the
 * snapshot's captured elements (squad → tab → card, font, badges,
 * specials), which re-runs the same handlers that set this state up
 * originally rather than re-implementing their side effects here.
 *
 * @param {object | null} snap
 */
restoreSnapshot_fn = function(snap) {
  __privateMethod(this, _KitPersonalisation_instances, clearCustomInputs_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, clearPlayerInput_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, clearSpecialInputs_fn).call(this);
  __privateSet(this, _selectedType, null);
  if (!snap) return;
  __privateSet(this, _selectedType, snap.type);
  if (snap.type) __privateMethod(this, _KitPersonalisation_instances, toggleFieldsForType_fn).call(this, snap.type);
  if (snap.type === "player") {
    if (snap.categoryBtn) {
      snap.categoryBtn.click();
    } else {
      __privateMethod(this, _KitPersonalisation_instances, autoSelectDefaultPlayer_fn).call(this);
    }
    if (snap.playerTab && snap.playerTab.getAttribute("aria-selected") !== "true") {
      snap.playerTab.click();
    }
    snap.playerCard?.click();
  } else if (snap.type === "custom") {
    if (__privateGet(this, _KitPersonalisation_instances, nameInput_get)) __privateGet(this, _KitPersonalisation_instances, nameInput_get).value = snap.name;
    if (__privateGet(this, _KitPersonalisation_instances, numberInput_get)) __privateGet(this, _KitPersonalisation_instances, numberInput_get).value = snap.number;
    __privateMethod(this, _KitPersonalisation_instances, updateNameCount_fn).call(this);
  }
  snap.fontRadio?.click();
  __privateMethod(this, _KitPersonalisation_instances, updateBadgeAvailability_fn).call(this);
  for (const btn of snap.badgeButtons) btn.click();
  for (const btn of snap.specialButtons) btn.click();
  __privateMethod(this, _KitPersonalisation_instances, updatePreview_fn).call(this);
  __privateMethod(this, _KitPersonalisation_instances, updatePreviewFont_fn).call(this);
};
hasNameOrNumber_fn = function() {
  if (__privateGet(this, _selectedType) === "player") {
    return __privateMethod(this, _KitPersonalisation_instances, getSelectedPlayerName_fn).call(this).length > 0;
  }
  const name = __privateGet(this, _KitPersonalisation_instances, nameInput_get)?.value.trim() ?? "";
  const number = __privateGet(this, _KitPersonalisation_instances, numberInput_get)?.value.trim() ?? "";
  return name.length > 0 || number.length > 0;
};
hasPersonalisation_fn = function() {
  return __privateMethod(this, _KitPersonalisation_instances, hasNameOrNumber_fn).call(this) || __privateMethod(this, _KitPersonalisation_instances, getSelectedBadges_fn).call(this).length > 0 || __privateMethod(this, _KitPersonalisation_instances, getSelectedSpecials_fn).call(this).length > 0;
};
if (!customElements.get("kit-personalisation")) {
  customElements.define("kit-personalisation", KitPersonalisation);
}
